{
  "schemaVersion": "cogo.action-capability-registry.v1",
  "sources": [
    "packages/cogo-runtime-v2/src/action-flow-engine.ts",
    "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
    "packages/cogo-action-registry/src/generated/action-consumer-catalog.v1.json"
  ],
  "actions": [
    {
      "name": "addTableRow",
      "category": "data",
      "label": "Add Table Row",
      "description": "Insert a row into a table/list state array. Defaults to prepending; set position='end' to append.",
      "params": [
        {
          "name": "target",
          "type": "string",
          "required": true,
          "description": "State path containing the table array"
        },
        {
          "name": "row",
          "type": "object",
          "required": true,
          "description": "Row object to insert"
        },
        {
          "name": "position",
          "type": "string",
          "default": "start",
          "description": "start | end"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": true
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/addTableRow",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": true,
        "ssr": true
      },
      "generationPolicy": "allow",
      "grounding": "table-mutation",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "immediate"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "addTableRow",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:addTableRow:position",
            "path": "position",
            "required": false,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:addTableRow:row",
            "path": "row",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:addTableRow:target",
            "path": "target",
            "required": true,
            "role": "target"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:addTableRow:sha256:5e680edc286f76bc1908e751533aa390759ed7860011a389f683935f75cfda7b",
            "kind": "state-target",
            "targetParam": "target"
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [],
        "missingConsumerPolicy": "reject-before-side-effects"
      }
    },
    {
      "name": "aiCancel",
      "category": "ai",
      "label": "Cancel AI Stream",
      "description": "Abort an active Gemini streaming response",
      "params": [
        {
          "name": "streamId",
          "type": "string",
          "default": "default",
          "description": "Stream identifier to cancel"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/aiCancel",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "adapter-only",
      "grounding": "ai-adapter",
      "evidence": [
        "packages/cogo-runtime-v2/src/gemini-stream-actions.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "aiCancel",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:aiCancel:streamId",
            "path": "streamId",
            "required": true,
            "role": "selector"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:aiCancel:sha256:00a686c87a99a2087cb7463476e17845ddb993eb883d83be362ef469943c0b72",
            "kind": "host-effect",
            "capabilityId": "host.ai-stream",
            "operation": "cancel"
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:aiCancel:sha256:ed403dea488c32d33729c4abad6c4d67ada083d4fa24134802b32ed705906d62",
            "capabilityId": "host.ai-stream",
            "operation": "cancel"
          }
        ],
        "requiredHostCapabilities": [
          "host.ai-stream"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "analyticsEvent",
      "category": "network",
      "label": "Analytics Event",
      "description": "Dispatch an analytics tracking event",
      "params": [
        {
          "name": "event",
          "type": "string",
          "required": true
        },
        {
          "name": "data",
          "type": "object"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/analyticsEvent",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "allow",
      "grounding": "generated",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "sensitive",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "immediate"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "analyticsEvent",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:analyticsEvent:data",
            "path": "data",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:analyticsEvent:event",
            "path": "event",
            "required": true,
            "role": "selector"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:analyticsEvent:sha256:3854970aed2866a46eb16548e2264ffa48bd12f6ae09922f9297c860401cf698",
            "kind": "host-effect",
            "capabilityId": "host.analytics",
            "operation": "dispatch"
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:analyticsEvent:sha256:21cab33b4314dc83e3c4f80fe276b623f81440f1293c6bb5aee87ff7cad9086a",
            "capabilityId": "host.analytics",
            "operation": "dispatch"
          }
        ],
        "requiredHostCapabilities": [
          "host.analytics"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "applyReportDesignTheme",
      "category": "ui",
      "label": "Apply Report Design Theme",
      "description": "Apply a report design-system theme to preview state and token references without changing report content.",
      "params": [
        {
          "name": "themeId",
          "type": "string",
          "required": true,
          "description": "Report design theme id to apply."
        },
        {
          "name": "surface",
          "type": "string",
          "default": "report-preview",
          "description": "Preview surface receiving the theme."
        },
        {
          "name": "accent",
          "type": "string",
          "description": "Optional accent token or color hint."
        },
        {
          "name": "tokenPatch",
          "type": "object",
          "description": "Optional token override patch emitted by the compiler."
        },
        {
          "name": "target",
          "type": "string",
          "default": "local.reportDesignTheme",
          "description": "State path that stores the applied theme summary."
        }
      ],
      "platform": {
        "web": true,
        "reactNative": false,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/applyReportDesignTheme",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": false,
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "allow",
      "grounding": "generated",
      "evidence": [
        "packages/cogo-runtime-v2/src/app-runtime-core.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "ui",
        "atomic": true,
        "completion": "immediate"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "applyReportDesignTheme",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:applyReportDesignTheme:accent",
            "path": "accent",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:applyReportDesignTheme:surface",
            "path": "surface",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:applyReportDesignTheme:target",
            "path": "target",
            "required": false,
            "role": "target"
          },
          {
            "channelId": "parameter-channel:applyReportDesignTheme:themeId",
            "path": "themeId",
            "required": true,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:applyReportDesignTheme:tokenPatch",
            "path": "tokenPatch",
            "required": false,
            "role": "payload"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:applyReportDesignTheme:sha256:b051a0c79a74232dcb566ebaab864992a6315b96c20f6e46b07e7443df0d985c",
            "kind": "return-capture",
            "capture": "step-name",
            "envelope": {
              "kind": "object",
              "properties": {
                "accent": {
                  "kind": "scalar",
                  "type": "string"
                },
                "appliedBy": {
                  "kind": "scalar",
                  "type": "string"
                },
                "surface": {
                  "kind": "scalar",
                  "type": "string"
                },
                "themeId": {
                  "kind": "scalar",
                  "type": "string"
                },
                "tokenPatch": {
                  "kind": "unknown"
                }
              },
              "required": [
                "accent",
                "appliedBy",
                "surface",
                "themeId",
                "tokenPatch"
              ]
            }
          },
          {
            "channelId": "result-channel:applyReportDesignTheme:sha256:04cd75e5f9a5ec74ebb94b05024bbf2a7ee36e557e76a819a4f9c5652d8a0cda",
            "kind": "state-target",
            "defaultTarget": "local.reportDesignStatus",
            "envelope": {
              "kind": "scalar",
              "type": "string"
            }
          },
          {
            "channelId": "result-channel:applyReportDesignTheme:sha256:07a404a0b19bcf27cef33893e57495033d903bc9ec772addec22884e670e525a",
            "kind": "state-target",
            "defaultTarget": "local.reportDesignPanelOpen",
            "envelope": {
              "kind": "scalar",
              "type": "boolean"
            }
          },
          {
            "channelId": "result-channel:applyReportDesignTheme:sha256:143b840d855807f3f5521244f6c1fae683793cc9e39d100dcbac117049948005",
            "kind": "state-target",
            "defaultTarget": "local.previewDesignAppliedAt",
            "envelope": {
              "kind": "scalar",
              "type": "string"
            }
          },
          {
            "channelId": "result-channel:applyReportDesignTheme:sha256:2a8f9a8bcd223d7ff2672c8e0c47b8d98282770c4dbc8606ed64e9aba9ae083b",
            "kind": "state-target",
            "targetParam": "target",
            "defaultTarget": "local.reportDesignTheme",
            "envelope": {
              "kind": "object",
              "properties": {
                "accent": {
                  "kind": "scalar",
                  "type": "string"
                },
                "appliedBy": {
                  "kind": "scalar",
                  "type": "string"
                },
                "surface": {
                  "kind": "scalar",
                  "type": "string"
                },
                "themeId": {
                  "kind": "scalar",
                  "type": "string"
                },
                "tokenPatch": {
                  "kind": "unknown"
                }
              },
              "required": [
                "accent",
                "appliedBy",
                "surface",
                "themeId",
                "tokenPatch"
              ]
            }
          },
          {
            "channelId": "result-channel:applyReportDesignTheme:sha256:3bcaa8633e119d625863c02ede85a7c07e498f53e1442c6350100ddb8cccf4a6",
            "kind": "state-target",
            "defaultTarget": "local.reportDesignAccent",
            "envelope": {
              "kind": "scalar",
              "type": "string"
            }
          },
          {
            "channelId": "result-channel:applyReportDesignTheme:sha256:4fbce59d078eec96a113f525d1ec4146980326cde172125d8b759ffede9ed9ec",
            "kind": "state-target",
            "defaultTarget": "local.reportDesignThemeId",
            "envelope": {
              "kind": "scalar",
              "type": "string"
            }
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [],
        "missingConsumerPolicy": "reject-before-side-effects"
      }
    },
    {
      "name": "batchAction",
      "category": "flow",
      "label": "Batch Action",
      "description": "Execute multiple actions in sequence",
      "params": [
        {
          "name": "actions",
          "type": "array",
          "required": true
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": true
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/batchAction",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": true
      },
      "generationPolicy": "allow",
      "grounding": "control-flow",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "business",
        "atomic": false,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "batchAction",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:batchAction:actions",
            "path": "actions",
            "required": true,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:batchAction:stopOnError",
            "path": "stopOnError",
            "required": false,
            "role": "guard"
          }
        ],
        "resultChannels": [],
        "hostCapabilities": [],
        "requiredHostCapabilities": [],
        "missingConsumerPolicy": "reject-before-side-effects"
      }
    },
    {
      "name": "callFlow",
      "category": "flow",
      "label": "Call Flow",
      "description": "Invoke a named sub-flow",
      "params": [
        {
          "name": "flow",
          "type": "string",
          "required": true,
          "description": "Flow name to invoke"
        },
        {
          "name": "context",
          "type": "object"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": true
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/callFlow",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": true
      },
      "generationPolicy": "allow",
      "grounding": "control-flow",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "business",
        "atomic": false,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "callFlow",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:callFlow:await",
            "path": "await",
            "required": false,
            "role": "guard"
          },
          {
            "channelId": "parameter-channel:callFlow:context",
            "path": "context",
            "required": false,
            "role": "payload"
          },
          {
            "aliases": [
              "flowName"
            ],
            "channelId": "parameter-channel:callFlow:flow",
            "path": "flow",
            "required": true,
            "role": "selector"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:callFlow:sha256:d5bc11f269f285b768f29210068f9dd1d5b5558daa0315388a1e92bf66d5309e",
            "kind": "host-registry",
            "capabilityId": "host.flow-registry",
            "selectorParam": "flow",
            "payloadParam": "context"
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:callFlow:sha256:2a57e685537b9cb5e043dbe6b86202bd9ddb33425b25f9c1045b9f3c993c2c35",
            "capabilityId": "host.flow-registry",
            "operation": "invoke"
          }
        ],
        "requiredHostCapabilities": [
          "host.flow-registry"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "cfAiGateway",
      "category": "ai",
      "label": "CF AI Gateway",
      "description": "Cloudflare AI Gateway for LLM caching, rate limiting, and logging (chat/complete/log)",
      "params": [
        {
          "name": "action",
          "type": "string",
          "required": true,
          "description": "Operation: chat | complete | log"
        },
        {
          "name": "prompt",
          "type": "string",
          "description": "Input prompt (for chat/complete)"
        },
        {
          "name": "model",
          "type": "string",
          "description": "Model name (for chat/complete)"
        },
        {
          "name": "provider",
          "type": "string",
          "default": "google-ai-studio",
          "description": "AI provider"
        },
        {
          "name": "logData",
          "type": "object",
          "description": "Log data (for log)"
        },
        {
          "name": "resultTarget",
          "type": "string",
          "default": "_results.cfAiGateway"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "requiresProxy": true,
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/cfAiGateway",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": "adapter"
      },
      "generationPolicy": "adapter-only",
      "grounding": "cloudflare-adapter",
      "evidence": [
        "packages/cogo-runtime-v2/src/cf-actions.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "privileged",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "cfAiGateway",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:cfAiGateway:action",
            "path": "action",
            "required": true,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:cfAiGateway:logData",
            "path": "logData",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:cfAiGateway:model",
            "path": "model",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:cfAiGateway:prompt",
            "path": "prompt",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:cfAiGateway:provider",
            "path": "provider",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:cfAiGateway:resultTarget",
            "path": "resultTarget",
            "required": false,
            "role": "target"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:cfAiGateway:sha256:09dcbd3f87a01b5f322c850668b541d6e702f78e7ebcf4d375c7c354d696498d",
            "kind": "state-target",
            "targetParam": "resultTarget",
            "defaultTarget": "_results.cfAiGateway"
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [
          "host.cloudflare"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "cfDurableObject",
      "category": "system",
      "label": "CF Durable Object",
      "description": "Cloudflare Durable Objects stateful edge compute (create/get/put/delete/alarm)",
      "params": [
        {
          "name": "action",
          "type": "string",
          "required": true,
          "description": "Operation: create | get | put | delete | alarm"
        },
        {
          "name": "objectId",
          "type": "string",
          "description": "DO instance ID"
        },
        {
          "name": "data",
          "type": "object",
          "description": "Data payload (for put)"
        },
        {
          "name": "alarmAt",
          "type": "string",
          "description": "ISO timestamp for alarm scheduling"
        },
        {
          "name": "resultTarget",
          "type": "string",
          "default": "_results.cfDurableObject"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "requiresProxy": true,
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/cfDurableObject",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": "adapter"
      },
      "generationPolicy": "adapter-only",
      "grounding": "cloudflare-adapter",
      "evidence": [
        "packages/cogo-runtime-v2/src/cf-actions.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "privileged",
      "semantics": {
        "domain": "system",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "cfDurableObject",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:cfDurableObject:action",
            "path": "action",
            "required": true,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:cfDurableObject:alarmAt",
            "path": "alarmAt",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:cfDurableObject:data",
            "path": "data",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:cfDurableObject:objectId",
            "path": "objectId",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:cfDurableObject:resultTarget",
            "path": "resultTarget",
            "required": false,
            "role": "target"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:cfDurableObject:sha256:4ec3e19a34649d30a7dddffc145019cbab68e4c22ce6f77179e4f8fb2a2fed92",
            "kind": "state-target",
            "targetParam": "resultTarget",
            "defaultTarget": "_results.cfDurableObject"
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [
          "host.cloudflare"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "cfKv",
      "category": "storage",
      "label": "CF KV Store",
      "description": "Cloudflare Workers KV key-value operations (get/set/delete/list)",
      "params": [
        {
          "name": "action",
          "type": "string",
          "required": true,
          "description": "Operation: get | set | delete | list"
        },
        {
          "name": "key",
          "type": "string",
          "description": "KV key (required for get/set/delete)"
        },
        {
          "name": "value",
          "type": "expression",
          "description": "Value to store (for set)"
        },
        {
          "name": "ttl",
          "type": "number",
          "description": "Expiration TTL in seconds (for set)"
        },
        {
          "name": "prefix",
          "type": "string",
          "description": "Key prefix filter (for list)"
        },
        {
          "name": "resultTarget",
          "type": "string",
          "default": "_results.cfKv"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "requiresProxy": true,
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/cfKv",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": "adapter"
      },
      "generationPolicy": "adapter-only",
      "grounding": "cloudflare-adapter",
      "evidence": [
        "packages/cogo-runtime-v2/src/cf-actions.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "privileged",
      "semantics": {
        "domain": "system",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "cfKv",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:cfKv:action",
            "path": "action",
            "required": true,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:cfKv:key",
            "path": "key",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:cfKv:prefix",
            "path": "prefix",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:cfKv:resultTarget",
            "path": "resultTarget",
            "required": false,
            "role": "target"
          },
          {
            "channelId": "parameter-channel:cfKv:ttl",
            "path": "ttl",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:cfKv:value",
            "path": "value",
            "required": false,
            "role": "payload"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:cfKv:sha256:2f909835aaa87743231ea0626253126f790a4c1dbb925db30a5e499bbbdf606d",
            "kind": "state-target",
            "targetParam": "resultTarget",
            "defaultTarget": "_results.cfKv"
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [
          "host.cloudflare"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "cfR2",
      "category": "storage",
      "label": "CF R2 Storage",
      "description": "Cloudflare R2 object storage operations (upload/download/list/delete)",
      "params": [
        {
          "name": "action",
          "type": "string",
          "required": true,
          "description": "Operation: upload | download | list | delete"
        },
        {
          "name": "path",
          "type": "string",
          "required": true,
          "description": "Object path (appId/ prefix enforced)"
        },
        {
          "name": "file",
          "type": "object",
          "description": "File to upload (for upload)"
        },
        {
          "name": "contentType",
          "type": "string",
          "description": "MIME type (for upload)"
        },
        {
          "name": "prefix",
          "type": "string",
          "description": "Path prefix filter (for list)"
        },
        {
          "name": "resultTarget",
          "type": "string",
          "default": "_results.cfR2"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "requiresProxy": true,
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/cfR2",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": "adapter"
      },
      "generationPolicy": "adapter-only",
      "grounding": "cloudflare-adapter",
      "evidence": [
        "packages/cogo-runtime-v2/src/cf-actions.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "privileged",
      "semantics": {
        "domain": "system",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "cfR2",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:cfR2:action",
            "path": "action",
            "required": true,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:cfR2:appId",
            "path": "appId",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:cfR2:contentType",
            "path": "contentType",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:cfR2:file",
            "path": "file",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:cfR2:path",
            "path": "path",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:cfR2:prefix",
            "path": "prefix",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:cfR2:resultTarget",
            "path": "resultTarget",
            "required": false,
            "role": "target"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:cfR2:sha256:fc62b8794e0f141b68138b7ceba8114b86f8ee4c22f167de4554e3b30a41e0a3",
            "kind": "state-target",
            "targetParam": "resultTarget",
            "defaultTarget": "_results.cfR2"
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [
          "host.cloudflare"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "clipboardRead",
      "category": "system",
      "label": "Read Clipboard",
      "description": "Read text from the system clipboard",
      "params": [
        {
          "name": "resultPath",
          "type": "string",
          "required": true
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/clipboardRead",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "allow",
      "grounding": "generated",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "sensitive",
      "semantics": {
        "domain": "system",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "clipboardRead",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:clipboardRead:resultPath",
            "path": "resultPath",
            "required": false,
            "role": "target"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:clipboardRead:sha256:9919f3dbd626847862f4265b195dcbd60775377c59382a9fcb4563e381fe7528",
            "kind": "host-effect",
            "capabilityId": "host.clipboard",
            "operation": "read"
          },
          {
            "channelId": "result-channel:clipboardRead:sha256:b5ffc09631635530942e64e742d0503f5f858b8d01a090eb0469df0bea43a09e",
            "kind": "state-target",
            "targetParam": "resultPath",
            "defaultTarget": "_results.clipboard"
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:clipboardRead:sha256:d83b36d4f34bd19d867db1032ea1b5a6e60c136b442551a8c05d82515bf15a54",
            "capabilityId": "host.clipboard",
            "operation": "read"
          }
        ],
        "requiredHostCapabilities": [
          "host.clipboard"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "cogo.formula.dependencies",
      "category": "data",
      "label": "Extract Formula Dependencies",
      "description": "Extract cell, range, and named-reference dependencies from a formula.",
      "params": [
        {
          "name": "formula",
          "type": "expression",
          "description": "Formula text, with or without a leading '='."
        },
        {
          "name": "expression",
          "type": "expression",
          "description": "Alias for formula when the caller already models formulas as expressions."
        },
        {
          "name": "position",
          "type": "object",
          "description": "Current sheet/row/column context for relative references."
        },
        {
          "name": "cells",
          "type": "object",
          "description": "Sparse A1 cell map used for whole-row/column range normalization."
        },
        {
          "name": "sheets",
          "type": "object",
          "description": "Workbook sheet matrix map used for whole-row/column range normalization."
        },
        {
          "name": "namedRefs",
          "type": "object",
          "description": "Named scalar, cell, or range references."
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": true
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/cogo.formula.dependencies",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": true
      },
      "generationPolicy": "allow",
      "grounding": "generated",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-runtime-v2/src/formula-actions.ts"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "cogo.formula.dependencies",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:cogo.formula.dependencies:allowReturnArray",
            "path": "allowReturnArray",
            "required": false,
            "role": "guard"
          },
          {
            "channelId": "parameter-channel:cogo.formula.dependencies:cells",
            "path": "cells",
            "required": false,
            "role": "payload"
          },
          {
            "aliases": [
              "expression"
            ],
            "channelId": "parameter-channel:cogo.formula.dependencies:formula",
            "path": "formula",
            "required": true,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:cogo.formula.dependencies:functions",
            "path": "functions",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:cogo.formula.dependencies:namedRefs",
            "path": "namedRefs",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:cogo.formula.dependencies:position",
            "path": "position",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:cogo.formula.dependencies:sheets",
            "path": "sheets",
            "required": false,
            "role": "payload"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:cogo.formula.dependencies:sha256:1182f31e9f03c5704bab18950e9381188a2a4411c1380c47c4fce875f9383d02",
            "kind": "return-capture",
            "capture": "step-name"
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [],
        "missingConsumerPolicy": "reject-before-side-effects"
      }
    },
    {
      "name": "cogo.formula.evaluate",
      "category": "data",
      "label": "Evaluate Formula",
      "description": "Evaluate an Excel-compatible formula through the Cogo runtime formula engine.",
      "params": [
        {
          "name": "formula",
          "type": "expression",
          "description": "Formula text, with or without a leading '='."
        },
        {
          "name": "expression",
          "type": "expression",
          "description": "Alias for formula when the caller already models formulas as expressions."
        },
        {
          "name": "position",
          "type": "object",
          "description": "Current sheet/row/column context for relative references."
        },
        {
          "name": "cells",
          "type": "object",
          "description": "Sparse A1 cell map, e.g. { A1: 1, 'Sheet2!B4': 2 }."
        },
        {
          "name": "sheets",
          "type": "object",
          "description": "Workbook sheet matrix map for range-backed formulas."
        },
        {
          "name": "namedRefs",
          "type": "object",
          "description": "Named scalar, cell, or range references."
        },
        {
          "name": "allowReturnArray",
          "type": "boolean",
          "default": false,
          "description": "Allow array formula return values."
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": true
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/cogo.formula.evaluate",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": true
      },
      "generationPolicy": "allow",
      "grounding": "generated",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-runtime-v2/src/formula-actions.ts"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "cogo.formula.evaluate",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:cogo.formula.evaluate:allowReturnArray",
            "path": "allowReturnArray",
            "required": false,
            "role": "guard"
          },
          {
            "channelId": "parameter-channel:cogo.formula.evaluate:cells",
            "path": "cells",
            "required": false,
            "role": "payload"
          },
          {
            "aliases": [
              "expression"
            ],
            "channelId": "parameter-channel:cogo.formula.evaluate:formula",
            "path": "formula",
            "required": true,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:cogo.formula.evaluate:functions",
            "path": "functions",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:cogo.formula.evaluate:namedRefs",
            "path": "namedRefs",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:cogo.formula.evaluate:position",
            "path": "position",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:cogo.formula.evaluate:sheets",
            "path": "sheets",
            "required": false,
            "role": "payload"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:cogo.formula.evaluate:sha256:1182f31e9f03c5704bab18950e9381188a2a4411c1380c47c4fce875f9383d02",
            "kind": "return-capture",
            "capture": "step-name"
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [],
        "missingConsumerPolicy": "reject-before-side-effects"
      }
    },
    {
      "name": "compute",
      "category": "data",
      "label": "Compute",
      "description": "Compute a value and write it to state. Use 'expression' for evaluator strings or 'value' for object/array literals with embedded #{...} refs. Result captured at _results.<step.name>.",
      "params": [
        {
          "name": "target",
          "type": "string",
          "required": true,
          "description": "State path to write the result"
        },
        {
          "name": "expression",
          "type": "expression",
          "description": "Compute-evaluator expression string"
        },
        {
          "name": "value",
          "type": "expression",
          "description": "Object/array literal (resolved deeply before write)"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": true
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/compute",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": true
      },
      "generationPolicy": "allow",
      "grounding": "generated",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "immediate"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "compute",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:compute:expression",
            "path": "expression",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:compute:target",
            "path": "target",
            "required": true,
            "role": "target"
          },
          {
            "channelId": "parameter-channel:compute:value",
            "path": "value",
            "required": false,
            "role": "payload"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:compute:sha256:1182f31e9f03c5704bab18950e9381188a2a4411c1380c47c4fce875f9383d02",
            "kind": "return-capture",
            "capture": "step-name"
          },
          {
            "channelId": "result-channel:compute:sha256:5e680edc286f76bc1908e751533aa390759ed7860011a389f683935f75cfda7b",
            "kind": "state-target",
            "targetParam": "target"
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [],
        "missingConsumerPolicy": "reject-before-side-effects"
      }
    },
    {
      "name": "computeDateRange",
      "category": "data",
      "label": "Compute Date Range",
      "description": "Calculate date range from preset (today, yesterday, 7days, etc.)",
      "params": [
        {
          "name": "range",
          "type": "string",
          "required": true,
          "description": "today | yesterday | 7days | 15days | 1month | 3months"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": true
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/computeDateRange",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": true
      },
      "generationPolicy": "allow",
      "grounding": "generated",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "immediate"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "computeDateRange",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:computeDateRange:range",
            "path": "range",
            "required": false,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:computeDateRange:statePrefix",
            "path": "statePrefix",
            "required": false,
            "role": "target"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:computeDateRange:sha256:e081ab32fc3b1df54c1765dcc8dc3d0e7c9a5a36303fb0a106bb010aa9905d41",
            "kind": "state-target",
            "targetParam": "statePrefix",
            "defaultTarget": "ui",
            "targetSuffixes": [
              "dateFrom",
              "dateFromCompact",
              "dateRange",
              "dateTo",
              "dateToCompact",
              "pageIndex"
            ]
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [],
        "missingConsumerPolicy": "reject-before-side-effects"
      }
    },
    {
      "name": "computeField",
      "category": "data",
      "label": "Compute Field",
      "description": "Compute a derived field for every row in a source array. The expression can reference item.<field>; target defaults to source.",
      "params": [
        {
          "name": "source",
          "type": "string",
          "required": true,
          "description": "State path containing the source array"
        },
        {
          "name": "field",
          "type": "string",
          "required": true,
          "description": "Field name to write on each row"
        },
        {
          "name": "expression",
          "type": "expression",
          "required": true,
          "description": "Per-row expression, e.g. item.price * item.qty"
        },
        {
          "name": "target",
          "type": "string",
          "description": "Optional state path to write the computed rows; defaults to source"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": true
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/computeField",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": true,
        "ssr": true
      },
      "generationPolicy": "allow",
      "grounding": "table-mutation",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "immediate"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "computeField",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:computeField:expression",
            "path": "expression",
            "required": true,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:computeField:field",
            "path": "field",
            "required": true,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:computeField:source",
            "path": "source",
            "required": true,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:computeField:target",
            "path": "target",
            "required": false,
            "role": "target"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:computeField:sha256:5e680edc286f76bc1908e751533aa390759ed7860011a389f683935f75cfda7b",
            "kind": "state-target",
            "targetParam": "target"
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [],
        "missingConsumerPolicy": "reject-before-side-effects"
      }
    },
    {
      "name": "conditionalDelay",
      "category": "flow",
      "label": "Conditional Delay",
      "description": "Wait only if a condition is true",
      "params": [
        {
          "name": "condition",
          "type": "expression",
          "required": true
        },
        {
          "name": "ms",
          "type": "number",
          "required": true
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": true
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/conditionalDelay",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": true
      },
      "generationPolicy": "allow",
      "grounding": "control-flow",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "business",
        "atomic": false,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "conditionalDelay",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:conditionalDelay:condition",
            "path": "condition",
            "required": true,
            "role": "guard"
          },
          {
            "aliases": [
              "ms"
            ],
            "channelId": "parameter-channel:conditionalDelay:duration",
            "path": "duration",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:conditionalDelay:maxWait",
            "path": "maxWait",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:conditionalDelay:pollInterval",
            "path": "pollInterval",
            "required": false,
            "role": "input"
          }
        ],
        "resultChannels": [],
        "hostCapabilities": [],
        "requiredHostCapabilities": [],
        "missingConsumerPolicy": "reject-before-side-effects"
      }
    },
    {
      "name": "confirmAction",
      "category": "ui",
      "label": "Confirm Action",
      "description": "Show a confirmation dialog and pause ActionFlow until the user confirms or cancels. Dispatches 'confirm' or 'cancel' events for downstream branching. Use for destructive or critical actions (place order, delete, irreversible writes).",
      "params": [
        {
          "name": "message",
          "type": "string",
          "required": true,
          "description": "Confirmation prompt body shown in the dialog."
        },
        {
          "name": "title",
          "type": "string",
          "description": "Optional dialog title. Defaults to a renderer-supplied label (e.g. 'Confirm')."
        },
        {
          "name": "confirmLabel",
          "type": "string",
          "description": "Label for the confirm button. Default: 'Confirm'."
        },
        {
          "name": "cancelLabel",
          "type": "string",
          "description": "Label for the cancel button. Default: 'Cancel'."
        },
        {
          "name": "dangerous",
          "type": "boolean",
          "description": "When true, the renderer styles the confirm button as destructive (red). Default: false."
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/confirmAction",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "allow",
      "grounding": "generated",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "ui",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "confirmAction",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:confirmAction:cancelLabel",
            "path": "cancelLabel",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:confirmAction:confirmLabel",
            "path": "confirmLabel",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:confirmAction:dangerous",
            "path": "dangerous",
            "required": false,
            "role": "guard"
          },
          {
            "channelId": "parameter-channel:confirmAction:message",
            "path": "message",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:confirmAction:title",
            "path": "title",
            "required": false,
            "role": "input"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:confirmAction:sha256:1647c22379ab901c1ff246a5f204eef77d589f110e99a202bd8b6406294609df",
            "kind": "host-effect",
            "capabilityId": "host.confirm",
            "operation": "confirm"
          },
          {
            "channelId": "result-channel:confirmAction:sha256:1182f31e9f03c5704bab18950e9381188a2a4411c1380c47c4fce875f9383d02",
            "kind": "return-capture",
            "capture": "step-name"
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:confirmAction:sha256:38534ea4073e3c881d3d7bcb224c91a3896839593d920954959c7297a231c0b6",
            "capabilityId": "host.confirm",
            "operation": "confirm"
          }
        ],
        "requiredHostCapabilities": [
          "host.confirm"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "copyToClipboard",
      "category": "system",
      "label": "Copy to Clipboard",
      "description": "Copy text to the system clipboard",
      "params": [
        {
          "name": "text",
          "type": "string",
          "required": true
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/copyToClipboard",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "allow",
      "grounding": "generated",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "sensitive",
      "semantics": {
        "domain": "system",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "copyToClipboard",
        "runtimeAliases": [],
        "reads": [
          {
            "aliases": [
              "value"
            ],
            "channelId": "parameter-channel:copyToClipboard:text",
            "path": "text",
            "required": false,
            "role": "payload"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:copyToClipboard:sha256:a847286f47917367bd7910b9b498be65b8f470be059e5cf77a8d9aaff03c3669",
            "kind": "host-effect",
            "capabilityId": "host.clipboard",
            "operation": "write"
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:copyToClipboard:sha256:8069d691693dd1fda7ad170ab115fa4a781a8810684471ba5559913e7bf93928",
            "capabilityId": "host.clipboard",
            "operation": "write"
          }
        ],
        "requiredHostCapabilities": [
          "host.clipboard"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "cropImage",
      "category": "media",
      "label": "Crop Image",
      "description": "Crop an image through a native/image-processing adapter.",
      "params": [],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/cropImage",
      "lifecycle": "active",
      "registryExposure": "runtime-only",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "adapter-only",
      "grounding": "native-adapter",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "system",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "cropImage",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:cropImage:imageId",
            "path": "imageId",
            "required": true,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:cropImage:ratio",
            "path": "ratio",
            "required": false,
            "role": "input"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:cropImage:sha256:31d960a73935e24db8bcabd5f2ddeaf4e19f36b696da5797af077da7088f844e",
            "kind": "host-effect",
            "capabilityId": "host.media",
            "operation": "crop-image"
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:cropImage:sha256:e0bef232890fd78a109fc887382e81fde88a573d1adb5a1fd7ebb3083876afe0",
            "capabilityId": "host.media",
            "operation": "crop-image"
          }
        ],
        "requiredHostCapabilities": [
          "host.media"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "cryptoAction",
      "category": "crypto",
      "label": "Crypto Hash",
      "description": "Compute cryptographic hash",
      "params": [
        {
          "name": "algorithm",
          "type": "string",
          "default": "SHA-256"
        },
        {
          "name": "data",
          "type": "string",
          "required": true
        },
        {
          "name": "resultPath",
          "type": "string"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": true
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/cryptoAction",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": true
      },
      "generationPolicy": "allow",
      "grounding": "generated",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "sensitive",
      "semantics": {
        "domain": "system",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "cryptoAction",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:cryptoAction:algorithm",
            "path": "algorithm",
            "required": false,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:cryptoAction:data",
            "path": "data",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:cryptoAction:key",
            "path": "key",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:cryptoAction:operation",
            "path": "operation",
            "required": false,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:cryptoAction:resultPath",
            "path": "resultPath",
            "required": false,
            "role": "target"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:cryptoAction:sha256:8e337a122c3182a6e78bbfb8db6f4808489d43922a4f2dde0618e50aed1176d1",
            "kind": "host-effect",
            "capabilityId": "host.crypto",
            "operation": "execute"
          },
          {
            "channelId": "result-channel:cryptoAction:sha256:afaa5bdbbfab8eb57e663d7d296d81e7c7e819ca54f4ec64e286e1a46a048c6f",
            "kind": "state-target",
            "targetParam": "resultPath",
            "defaultTarget": "_results.crypto"
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:cryptoAction:sha256:8bfa9493f16732a62fab5fdd4fbde058e01a8fd2b1f091b10967031655079938",
            "capabilityId": "host.crypto",
            "operation": "execute"
          }
        ],
        "requiredHostCapabilities": [
          "host.crypto"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "csvExport",
      "category": "data",
      "label": "CSV Export",
      "description": "Serialize rows to CSV, write the payload to resultTarget, and download it when a platform adapter is present.",
      "params": [
        {
          "name": "data",
          "type": "expression",
          "required": true,
          "description": "Array of row objects to export"
        },
        {
          "name": "columns",
          "type": "array",
          "description": "Optional column spec [{key, header}] — defaults to the keys of the first row"
        },
        {
          "name": "filename",
          "type": "string",
          "default": "export.csv",
          "description": "Download filename"
        },
        {
          "name": "resultTarget",
          "type": "string",
          "default": "_results.csvExport",
          "description": "State path for the serialized CSV payload"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": true
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/csvExport",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": true
      },
      "generationPolicy": "allow",
      "grounding": "export",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "immediate"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "csvExport",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:csvExport:columns",
            "path": "columns",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:csvExport:data",
            "path": "data",
            "required": true,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:csvExport:filename",
            "path": "filename",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:csvExport:resultTarget",
            "path": "resultTarget",
            "required": false,
            "role": "target"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:csvExport:sha256:3e5d66844d07271845e3eb20f9f451ba1e0f9132e0bf253ba6d1d8324587a5e3",
            "kind": "host-effect",
            "capabilityId": "host.download",
            "operation": "csv"
          },
          {
            "channelId": "result-channel:csvExport:sha256:c68cc4398252128bb3581e2be941a948b0939b85db3ff156297a2f2c2b12ba49",
            "kind": "state-target",
            "targetParam": "resultTarget",
            "defaultTarget": "_results.csvExport"
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:csvExport:sha256:4eb88c47e1a639d4336a30033a9d084c6db3f84e055a507ff5065bd3f942c799",
            "capabilityId": "host.download",
            "operation": "csv"
          }
        ],
        "requiredHostCapabilities": [
          "host.download"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "datasource.call",
      "category": "data",
      "label": "Datasource Call",
      "description": "Execute a source-derived datasource call through the runtime datasource adapter.",
      "params": [],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": true
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/datasource.call",
      "lifecycle": "active",
      "registryExposure": "runtime-only",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": true
      },
      "generationPolicy": "adapter-only",
      "grounding": "datasource-adapter",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "datasource.call",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:datasource.call:$",
            "path": "$",
            "required": false,
            "role": "payload"
          },
          {
            "aliases": [
              "source"
            ],
            "channelId": "parameter-channel:datasource.call:datasourceId",
            "path": "datasourceId",
            "required": false,
            "role": "selector"
          },
          {
            "aliases": [
              "target"
            ],
            "channelId": "parameter-channel:datasource.call:resultTarget",
            "path": "resultTarget",
            "required": false,
            "role": "target"
          },
          {
            "channelId": "parameter-channel:datasource.call:sourceExpression",
            "path": "sourceExpression",
            "required": false,
            "role": "input"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:datasource.call:sha256:1182f31e9f03c5704bab18950e9381188a2a4411c1380c47c4fce875f9383d02",
            "kind": "return-capture",
            "capture": "step-name"
          },
          {
            "channelId": "result-channel:datasource.call:sha256:cfa477a83e214c8089a53ed6b0f1b8ef3c0729ade8233b071fd27086dcec6287",
            "kind": "state-target",
            "targetParam": "resultTarget"
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [
          "host.datasource"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "debounceAction",
      "category": "flow",
      "label": "Debounce Action",
      "description": "Debounce an action call",
      "params": [
        {
          "name": "action",
          "type": "string",
          "required": true
        },
        {
          "name": "params",
          "type": "object"
        },
        {
          "name": "delay",
          "type": "number",
          "default": 300
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": true
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/debounceAction",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": true
      },
      "generationPolicy": "allow",
      "grounding": "control-flow",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "business",
        "atomic": false,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "debounceAction",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:debounceAction:action",
            "path": "action",
            "required": true,
            "role": "selector"
          },
          {
            "aliases": [
              "wait"
            ],
            "channelId": "parameter-channel:debounceAction:delay",
            "path": "delay",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:debounceAction:key",
            "path": "key",
            "required": false,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:debounceAction:leading",
            "path": "leading",
            "required": false,
            "role": "guard"
          },
          {
            "channelId": "parameter-channel:debounceAction:maxWait",
            "path": "maxWait",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:debounceAction:params",
            "path": "params",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:debounceAction:trailing",
            "path": "trailing",
            "required": false,
            "role": "guard"
          }
        ],
        "resultChannels": [],
        "hostCapabilities": [],
        "requiredHostCapabilities": [],
        "missingConsumerPolicy": "reject-before-side-effects"
      }
    },
    {
      "name": "delay",
      "category": "flow",
      "label": "Delay",
      "description": "Wait for a specified duration",
      "params": [
        {
          "name": "ms",
          "type": "number",
          "required": true,
          "description": "Milliseconds to wait"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": true
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/delay",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": true
      },
      "generationPolicy": "allow",
      "grounding": "control-flow",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "delay",
        "runtimeAliases": [],
        "reads": [
          {
            "aliases": [
              "ms"
            ],
            "channelId": "parameter-channel:delay:duration",
            "path": "duration",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:delay:unit",
            "path": "unit",
            "required": false,
            "role": "selector"
          }
        ],
        "resultChannels": [],
        "hostCapabilities": [],
        "requiredHostCapabilities": [],
        "missingConsumerPolicy": "reject-before-side-effects"
      }
    },
    {
      "name": "deleteTableRow",
      "category": "data",
      "label": "Delete Table Row",
      "description": "Delete a row by index from a table/list state array.",
      "params": [
        {
          "name": "target",
          "type": "string",
          "required": true,
          "description": "State path containing the table array"
        },
        {
          "name": "rowIndex",
          "type": "number",
          "required": true,
          "description": "Zero-based row index to delete"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": true
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/deleteTableRow",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": true,
        "ssr": true
      },
      "generationPolicy": "allow",
      "grounding": "table-mutation",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "immediate"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "deleteTableRow",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:deleteTableRow:rowIndex",
            "path": "rowIndex",
            "required": true,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:deleteTableRow:target",
            "path": "target",
            "required": true,
            "role": "target"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:deleteTableRow:sha256:5e680edc286f76bc1908e751533aa390759ed7860011a389f683935f75cfda7b",
            "kind": "state-target",
            "targetParam": "target"
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [],
        "missingConsumerPolicy": "reject-before-side-effects"
      }
    },
    {
      "name": "dispatchStoreAction",
      "category": "state",
      "label": "Dispatch Store Action",
      "description": "Dispatch to an injected StoreActionRegistry handler.",
      "params": [],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": true
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/dispatchStoreAction",
      "lifecycle": "active",
      "registryExposure": "runtime-only",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": true
      },
      "generationPolicy": "adapter-only",
      "grounding": "store-adapter",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "dispatchStoreAction",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:dispatchStoreAction:handler",
            "path": "handler",
            "required": true,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:dispatchStoreAction:params",
            "path": "params",
            "required": false,
            "role": "payload"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:dispatchStoreAction:sha256:4c81038a9e12e291c5d34b39f80146ba1397ac036e9b266b87792b42ca2c4342",
            "kind": "host-registry",
            "capabilityId": "host.store-action",
            "selectorParam": "handler",
            "payloadParam": "params"
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:dispatchStoreAction:sha256:107fc82a092a88d5b70d4d996c864964ecdaf17b9dded72650b5443ac896e631",
            "capabilityId": "host.store-action",
            "operation": "invoke"
          }
        ],
        "requiredHostCapabilities": [
          "host.store-action"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "downloadAction",
      "category": "system",
      "label": "Download File",
      "description": "Download a file from a URL or blob. On RN uses expo-file-system + expo-sharing.",
      "params": [
        {
          "name": "url",
          "type": "string",
          "required": true
        },
        {
          "name": "filename",
          "type": "string"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/downloadAction",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "allow",
      "grounding": "generated",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "sensitive",
      "semantics": {
        "domain": "system",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "downloadAction",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:downloadAction:filename",
            "path": "filename",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:downloadAction:headers",
            "path": "headers",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:downloadAction:url",
            "path": "url",
            "required": true,
            "role": "input"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:downloadAction:sha256:252314cbe22caa39be75b8096b4e84eae1c2ae87adee7d86850256ce9d27cd94",
            "kind": "host-effect",
            "capabilityId": "host.download",
            "operation": "download"
          },
          {
            "channelId": "result-channel:downloadAction:sha256:495468431c60297647ef4121fb3c688160a0ea488825c83f444dc5fafde49b7f",
            "kind": "host-effect",
            "when": {
              "param": "headers",
              "present": true
            },
            "capabilityId": "host.download",
            "operation": "download"
          },
          {
            "channelId": "result-channel:downloadAction:sha256:acae841e2fe57cdfd7f8abad370e62e4063be2b759a7839c034fdb4a07dd1586",
            "kind": "host-effect",
            "when": {
              "param": "headers",
              "present": true
            },
            "capabilityId": "host.fetch",
            "operation": "fetch-with-headers"
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:downloadAction:sha256:1fbddf5ceefbcb226b20f2af84456b28afe9e493a1d3c52cb9eea42a870cee6b",
            "capabilityId": "host.download",
            "operation": "download"
          },
          {
            "channelId": "host-channel:downloadAction:sha256:e5a6ad624949fdee93f444ca2b2f7aa55331903632f55e8f1c59498112ea031f",
            "capabilityId": "host.download",
            "operation": "download",
            "when": {
              "param": "headers",
              "present": true
            }
          },
          {
            "channelId": "host-channel:downloadAction:sha256:570a600a57c9d6ae1bf2949fbc73c0a6b7c80fa1f835956d895f3aaebe65b9ef",
            "capabilityId": "host.fetch",
            "operation": "fetch-with-headers",
            "when": {
              "param": "headers",
              "present": true
            }
          }
        ],
        "requiredHostCapabilities": [
          "host.download"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "emitEvent",
      "category": "ui",
      "label": "Emit Event",
      "description": "Dispatch a named app event to ActionFlow listeners and the host event bus.",
      "params": [
        {
          "name": "event",
          "type": "string",
          "required": true,
          "description": "Event name consumed by flow.on listeners and host subscribers."
        },
        {
          "name": "payload",
          "type": "object",
          "description": "Optional event payload."
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [
        "emit"
      ],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/emitEvent",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "allow",
      "grounding": "host-callback",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "event",
        "atomic": true,
        "completion": "accepted"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "emitEvent",
        "runtimeAliases": [
          "emit"
        ],
        "reads": [
          {
            "aliases": [
              "payload"
            ],
            "channelId": "parameter-channel:emitEvent:data",
            "path": "data",
            "required": false,
            "role": "payload"
          },
          {
            "aliases": [
              "eventName",
              "name"
            ],
            "channelId": "parameter-channel:emitEvent:event",
            "path": "event",
            "required": true,
            "role": "selector"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:emitEvent:sha256:aa2286141df53445921eac465e25ced88872643bc0afa391df8c41710ed0bdd9",
            "kind": "host-effect",
            "capabilityId": "host.event-bus",
            "operation": "emit"
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:emitEvent:sha256:4493a1b02cf9c435d79090456686c7bd4254369bec3a41224367fce1e1fdd2dd",
            "capabilityId": "host.event-bus",
            "operation": "emit"
          }
        ],
        "requiredHostCapabilities": [
          "host.event-bus"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "fileUpload",
      "category": "system",
      "label": "File Upload",
      "description": "Open file picker for upload",
      "params": [
        {
          "name": "accept",
          "type": "string",
          "description": "MIME type filter"
        },
        {
          "name": "resultPath",
          "type": "string"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/fileUpload",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "adapter-only",
      "grounding": "native-adapter",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "sensitive",
      "semantics": {
        "domain": "system",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "fileUpload",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:fileUpload:accept",
            "path": "accept",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:fileUpload:field",
            "path": "field",
            "required": false,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:fileUpload:maxSize",
            "path": "maxSize",
            "required": false,
            "role": "guard"
          },
          {
            "channelId": "parameter-channel:fileUpload:resultPath",
            "path": "resultPath",
            "required": false,
            "role": "target"
          },
          {
            "channelId": "parameter-channel:fileUpload:url",
            "path": "url",
            "required": false,
            "role": "input"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:fileUpload:sha256:d6aeb764f079b83284b6ae66d943e17b99fa63da5d8b1ef9fe4c25047ce0d4b8",
            "kind": "host-effect",
            "capabilityId": "host.file-picker",
            "operation": "pick-and-upload"
          },
          {
            "channelId": "result-channel:fileUpload:sha256:e0014257c41211bc120105c8886e5b6c3a4688335ebf7365886187abb0843093",
            "kind": "state-target",
            "targetParam": "resultPath",
            "defaultTarget": "_results.file"
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:fileUpload:sha256:57c2e990f49e615953941f87eb41f1e822754d63a91d4b0b972cce2795ecf5b9",
            "capabilityId": "host.file-picker",
            "operation": "pick-and-upload"
          }
        ],
        "requiredHostCapabilities": [
          "host.fetch",
          "host.file-picker"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "firebaseAuth",
      "category": "auth",
      "label": "Firebase Auth (Deprecated)",
      "description": "Firebase authentication operation — DEPRECATED: use supabaseAuth instead",
      "params": [
        {
          "name": "action",
          "type": "string",
          "required": true,
          "description": "signIn | signUp | signOut"
        },
        {
          "name": "email",
          "type": "string"
        },
        {
          "name": "password",
          "type": "string"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "deprecated": true,
      "replacedBy": "supabaseAuth",
      "aliases": [],
      "canonicalAction": "supabaseAuth",
      "ontologyIri": "https://cogo.xyz/instances/action/firebaseAuth",
      "lifecycle": "deprecated",
      "registryExposure": "public",
      "runtimeImplemented": false,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "alias-only",
      "grounding": "generated",
      "evidence": [
        "packages/cogo-action-registry/src/registry.ts"
      ],
      "securityClass": "sensitive",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "completed"
      }
    },
    {
      "name": "firestoreAction",
      "category": "data",
      "label": "Firestore (Deprecated)",
      "description": "Firestore CRUD operation — DEPRECATED: use supabaseQuery instead",
      "params": [
        {
          "name": "operation",
          "type": "string",
          "required": true,
          "description": "get | set | update | delete | query"
        },
        {
          "name": "collection",
          "type": "string",
          "required": true
        },
        {
          "name": "docId",
          "type": "string"
        },
        {
          "name": "data",
          "type": "object"
        },
        {
          "name": "resultPath",
          "type": "string"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "deprecated": true,
      "replacedBy": "supabaseQuery",
      "aliases": [],
      "canonicalAction": "supabaseQuery",
      "ontologyIri": "https://cogo.xyz/instances/action/firestoreAction",
      "lifecycle": "deprecated",
      "registryExposure": "public",
      "runtimeImplemented": false,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "alias-only",
      "grounding": "generated",
      "evidence": [
        "packages/cogo-action-registry/src/registry.ts"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "completed"
      }
    },
    {
      "name": "formValidate",
      "deprecated": true,
      "replacedBy": "validate",
      "deprecatedMessage": "formValidate has no runtime-v2 executor; use validate.",
      "category": "form",
      "label": "Validate Form",
      "description": "Validate form fields against rules",
      "params": [
        {
          "name": "fields",
          "type": "object",
          "required": true
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": "validate",
      "ontologyIri": "https://cogo.xyz/instances/action/formValidate",
      "lifecycle": "deprecated",
      "registryExposure": "public",
      "runtimeImplemented": false,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "alias-only",
      "grounding": "generated",
      "evidence": [
        "packages/cogo-action-registry/src/registry.ts"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "immediate"
      }
    },
    {
      "name": "geminiAction",
      "category": "ai",
      "label": "Gemini AI",
      "description": "Call Gemini AI model",
      "params": [
        {
          "name": "prompt",
          "type": "string",
          "required": true
        },
        {
          "name": "model",
          "type": "string",
          "default": "gemini-2.5-pro"
        },
        {
          "name": "resultPath",
          "type": "string"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": true
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/geminiAction",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": "adapter"
      },
      "generationPolicy": "adapter-only",
      "grounding": "ai-adapter",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "geminiAction",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:geminiAction:apiKey",
            "path": "apiKey",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:geminiAction:exposedActions",
            "path": "exposedActions",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:geminiAction:maxToolCalls",
            "path": "maxToolCalls",
            "required": false,
            "role": "guard"
          },
          {
            "channelId": "parameter-channel:geminiAction:model",
            "path": "model",
            "required": false,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:geminiAction:prompt",
            "path": "prompt",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:geminiAction:resultTarget",
            "path": "resultTarget",
            "required": false,
            "role": "target"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:geminiAction:sha256:21bf98de214eff4573eca42edfa55d148568c3c1cf177d93cef9ad2a7f1b1463",
            "kind": "state-target",
            "targetParam": "resultTarget",
            "defaultTarget": "_results.gemini"
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [
          "host.gemini"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "geminiFunctionCall",
      "category": "ai",
      "label": "Gemini Function Call (Agent)",
      "description": "Multi-turn agent loop where Gemini calls ActionDefs as tools",
      "params": [
        {
          "name": "prompt",
          "type": "string",
          "required": true,
          "description": "Input prompt for the agent"
        },
        {
          "name": "tools",
          "type": "array",
          "required": true,
          "description": "ActionDef names to expose as tools"
        },
        {
          "name": "maxTurns",
          "type": "number",
          "default": 5,
          "description": "Max conversation turns"
        },
        {
          "name": "model",
          "type": "string",
          "default": "gemini-2.5-flash"
        },
        {
          "name": "systemPrompt",
          "type": "string",
          "description": "System prompt for agent context"
        },
        {
          "name": "tokenBudget",
          "type": "number",
          "default": 20000,
          "description": "Max token budget"
        },
        {
          "name": "resultTarget",
          "type": "string",
          "default": "_results.agent"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "requiresProxy": true,
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/geminiFunctionCall",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": "adapter"
      },
      "generationPolicy": "adapter-only",
      "grounding": "ai-adapter",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "privileged",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "geminiFunctionCall",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:geminiFunctionCall:apiKey",
            "path": "apiKey",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:geminiFunctionCall:maxTurns",
            "path": "maxTurns",
            "required": false,
            "role": "guard"
          },
          {
            "channelId": "parameter-channel:geminiFunctionCall:model",
            "path": "model",
            "required": false,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:geminiFunctionCall:prompt",
            "path": "prompt",
            "required": true,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:geminiFunctionCall:resultTarget",
            "path": "resultTarget",
            "required": false,
            "role": "target"
          },
          {
            "channelId": "parameter-channel:geminiFunctionCall:systemPrompt",
            "path": "systemPrompt",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:geminiFunctionCall:tokenBudget",
            "path": "tokenBudget",
            "required": false,
            "role": "guard"
          },
          {
            "channelId": "parameter-channel:geminiFunctionCall:tools",
            "path": "tools",
            "required": false,
            "role": "payload"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:geminiFunctionCall:sha256:b5fb59896c2c37f9703ad8507d1fe9719ad55e9aea23d9a0e08ab34287b292fb",
            "kind": "state-target",
            "targetParam": "resultTarget",
            "defaultTarget": "_results.agent"
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [
          "host.gemini"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "geminiStream",
      "category": "ai",
      "label": "Gemini Stream",
      "description": "Stream Gemini AI response token-by-token with real-time UI updates",
      "params": [
        {
          "name": "prompt",
          "type": "string",
          "required": true,
          "description": "Input prompt"
        },
        {
          "name": "model",
          "type": "string",
          "default": "gemini-2.5-flash"
        },
        {
          "name": "streamId",
          "type": "string",
          "default": "default",
          "description": "Stream identifier for cancel"
        },
        {
          "name": "resultTarget",
          "type": "string",
          "default": "_results.stream"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "requiresProxy": true,
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/geminiStream",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "adapter-only",
      "grounding": "ai-adapter",
      "evidence": [
        "packages/cogo-runtime-v2/src/gemini-stream-actions.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "privileged",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "geminiStream",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:geminiStream:model",
            "path": "model",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:geminiStream:prompt",
            "path": "prompt",
            "required": true,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:geminiStream:resultTarget",
            "path": "resultTarget",
            "required": false,
            "role": "target"
          },
          {
            "channelId": "parameter-channel:geminiStream:streamId",
            "path": "streamId",
            "required": false,
            "role": "selector"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:geminiStream:sha256:cfb9212766040825bc935dcb8e37e20a7b65fe00698a89adbb4f3658caa0490c",
            "kind": "state-target",
            "targetParam": "resultTarget",
            "defaultTarget": "_results.stream"
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [
          "host.ai-stream"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "geminiVision",
      "category": "ai",
      "label": "Gemini Vision",
      "description": "Analyze images with Gemini multimodal model",
      "params": [
        {
          "name": "prompt",
          "type": "string",
          "required": true,
          "description": "Analysis prompt"
        },
        {
          "name": "imageUrl",
          "type": "string",
          "description": "Single image URL"
        },
        {
          "name": "imageBase64",
          "type": "string",
          "description": "Single image base64"
        },
        {
          "name": "images",
          "type": "array",
          "description": "Multi-image array [{url?, base64?, mimeType}]"
        },
        {
          "name": "mimeType",
          "type": "string",
          "default": "image/jpeg",
          "description": "MIME type for base64 image"
        },
        {
          "name": "model",
          "type": "string",
          "default": "gemini-2.5-flash"
        },
        {
          "name": "resultTarget",
          "type": "string",
          "default": "_results.vision"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "requiresProxy": true,
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/geminiVision",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": "adapter"
      },
      "generationPolicy": "adapter-only",
      "grounding": "ai-adapter",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "privileged",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "geminiVision",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:geminiVision:apiKey",
            "path": "apiKey",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:geminiVision:imageBase64",
            "path": "imageBase64",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:geminiVision:imageUrl",
            "path": "imageUrl",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:geminiVision:images",
            "path": "images",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:geminiVision:mimeType",
            "path": "mimeType",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:geminiVision:model",
            "path": "model",
            "required": false,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:geminiVision:prompt",
            "path": "prompt",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:geminiVision:resultTarget",
            "path": "resultTarget",
            "required": false,
            "role": "target"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:geminiVision:sha256:4db46be8fb19e0d969e20b13450f245a7bdabc2ca623a19bd20afe4600c3fdbc",
            "kind": "state-target",
            "targetParam": "resultTarget",
            "defaultTarget": "_results.vision"
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [
          "host.gemini"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "geolocation",
      "category": "system",
      "label": "Geolocation",
      "description": "Get the user's current location",
      "params": [
        {
          "name": "resultPath",
          "type": "string",
          "required": true
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/geolocation",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "allow",
      "grounding": "generated",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "sensitive",
      "semantics": {
        "domain": "system",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "geolocation",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:geolocation:accuracy",
            "path": "accuracy",
            "required": false,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:geolocation:resultPath",
            "path": "resultPath",
            "required": false,
            "role": "target"
          },
          {
            "channelId": "parameter-channel:geolocation:timeout",
            "path": "timeout",
            "required": false,
            "role": "input"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:geolocation:sha256:959390f841bbde6f8feaf8ef954241c805e3e29b80b4c00188813928d56c15a6",
            "kind": "host-effect",
            "capabilityId": "host.geolocation",
            "operation": "get"
          },
          {
            "channelId": "result-channel:geolocation:sha256:90566fb667a3d359ed4c833ef923037ee976570d13691220de65555d67a769a1",
            "kind": "state-target",
            "targetParam": "resultPath",
            "defaultTarget": "_results.geo"
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:geolocation:sha256:9b8a16576997fd6651ee174d6f636e681a5bcaad9815e3032a116f8c26445df1",
            "capabilityId": "host.geolocation",
            "operation": "get"
          }
        ],
        "requiredHostCapabilities": [
          "host.geolocation"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "goLink",
      "category": "navigation",
      "label": "Open Link",
      "description": "Open an external URL",
      "params": [
        {
          "name": "url",
          "type": "string",
          "required": true
        },
        {
          "name": "newTab",
          "type": "boolean",
          "default": true
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/goLink",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "allow",
      "grounding": "generated",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "external-link",
        "atomic": true,
        "completion": "accepted"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "goLink",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:goLink:newTab",
            "path": "newTab",
            "required": false,
            "role": "guard"
          },
          {
            "channelId": "parameter-channel:goLink:url",
            "path": "url",
            "required": true,
            "role": "input"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:goLink:sha256:66080c57fb1b924a01de73826b35f350eb8b265ca2272038f9877e0b1976d0ca",
            "kind": "host-effect",
            "capabilityId": "host.navigation",
            "operation": "open-external"
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:goLink:sha256:5285fc8bd9638ace0efaf2a8df9e506111ad886afa82412b15878dab8174acf1",
            "capabilityId": "host.navigation",
            "operation": "open-external"
          }
        ],
        "requiredHostCapabilities": [
          "host.navigation"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "googleFcm",
      "category": "network",
      "label": "Google FCM Push",
      "description": "Send push notification via Firebase Cloud Messaging through server-side proxy",
      "params": [
        {
          "name": "userId",
          "type": "string",
          "description": "Look up token from user_push_tokens table"
        },
        {
          "name": "token",
          "type": "string",
          "description": "Direct FCM registration token"
        },
        {
          "name": "title",
          "type": "string",
          "required": true,
          "description": "Notification title"
        },
        {
          "name": "body",
          "type": "string",
          "required": true,
          "description": "Notification body text"
        },
        {
          "name": "data",
          "type": "object",
          "description": "Custom data payload for the notification"
        },
        {
          "name": "resultTarget",
          "type": "string",
          "default": "_results.googleFcm",
          "description": "State path for result"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "requiresProxy": true,
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/googleFcm",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": "adapter"
      },
      "generationPolicy": "adapter-only",
      "grounding": "google-adapter",
      "evidence": [
        "packages/cogo-runtime-v2/src/google-actions.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "privileged",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "googleFcm",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:googleFcm:body",
            "path": "body",
            "required": true,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:googleFcm:data",
            "path": "data",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:googleFcm:resultTarget",
            "path": "resultTarget",
            "required": false,
            "role": "target"
          },
          {
            "channelId": "parameter-channel:googleFcm:title",
            "path": "title",
            "required": true,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:googleFcm:token",
            "path": "token",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:googleFcm:userId",
            "path": "userId",
            "required": false,
            "role": "input"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:googleFcm:sha256:188f5e326bcb99af6fcb82a92b80cdf6d25a4e313e13c45199666b70632f191a",
            "kind": "state-target",
            "targetParam": "resultTarget",
            "defaultTarget": "_results.googleFcm"
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [
          "host.google-api"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "googleGmail",
      "category": "network",
      "label": "Google Gmail",
      "description": "Send email via Gmail API through server-side proxy (service account)",
      "params": [
        {
          "name": "to",
          "type": "string",
          "required": true,
          "description": "Recipient email address"
        },
        {
          "name": "subject",
          "type": "string",
          "required": true,
          "description": "Email subject line"
        },
        {
          "name": "body",
          "type": "string",
          "required": true,
          "description": "Email body (HTML supported)"
        },
        {
          "name": "cc",
          "type": "string",
          "description": "CC recipient(s)"
        },
        {
          "name": "bcc",
          "type": "string",
          "description": "BCC recipient(s)"
        },
        {
          "name": "resultTarget",
          "type": "string",
          "default": "_results.googleGmail",
          "description": "State path for result"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "requiresProxy": true,
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/googleGmail",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": "adapter"
      },
      "generationPolicy": "adapter-only",
      "grounding": "google-adapter",
      "evidence": [
        "packages/cogo-runtime-v2/src/google-actions.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "privileged",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "googleGmail",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:googleGmail:bcc",
            "path": "bcc",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:googleGmail:body",
            "path": "body",
            "required": true,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:googleGmail:cc",
            "path": "cc",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:googleGmail:resultTarget",
            "path": "resultTarget",
            "required": false,
            "role": "target"
          },
          {
            "channelId": "parameter-channel:googleGmail:subject",
            "path": "subject",
            "required": true,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:googleGmail:to",
            "path": "to",
            "required": true,
            "role": "input"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:googleGmail:sha256:9eab7ddc891f92b1292b961d11f46afe0a37f2c637b3ea7d1d3ec4caa506c9ee",
            "kind": "state-target",
            "targetParam": "resultTarget",
            "defaultTarget": "_results.googleGmail"
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [
          "host.google-api"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "graphqlAction",
      "category": "network",
      "label": "GraphQL",
      "description": "Execute a GraphQL query or mutation",
      "params": [
        {
          "name": "endpoint",
          "type": "string",
          "required": true
        },
        {
          "name": "query",
          "type": "string",
          "required": true
        },
        {
          "name": "variables",
          "type": "object"
        },
        {
          "name": "resultPath",
          "type": "string"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": true
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/graphqlAction",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": "adapter"
      },
      "generationPolicy": "adapter-only",
      "grounding": "network-adapter",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "sensitive",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "graphqlAction",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:graphqlAction:headers",
            "path": "headers",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:graphqlAction:query",
            "path": "query",
            "required": true,
            "role": "payload"
          },
          {
            "aliases": [
              "resultPath"
            ],
            "channelId": "parameter-channel:graphqlAction:resultTarget",
            "path": "resultTarget",
            "required": false,
            "role": "target"
          },
          {
            "aliases": [
              "endpoint"
            ],
            "channelId": "parameter-channel:graphqlAction:url",
            "path": "url",
            "required": true,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:graphqlAction:variables",
            "path": "variables",
            "required": false,
            "role": "payload"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:graphqlAction:sha256:fb1264ee5b1547a360f7664395a913d25d446370db7026e50214a907e8bad0f9",
            "kind": "state-target",
            "targetParam": "resultTarget",
            "defaultTarget": "_results.graphql"
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [
          "host.fetch"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "groupBy",
      "category": "data",
      "label": "Group By",
      "description": "Group rows from a source array by keyField, optionally substring-slicing the key and summing numeric fields into the target array.",
      "params": [
        {
          "name": "source",
          "type": "string",
          "required": true,
          "description": "State path containing the source array"
        },
        {
          "name": "keyField",
          "type": "string",
          "required": true,
          "description": "Object field used as the grouping key"
        },
        {
          "name": "keySlice",
          "type": "number",
          "description": "Optional substring length for grouping key normalization"
        },
        {
          "name": "sumFields",
          "type": "array",
          "description": "Numeric fields to sum per group"
        },
        {
          "name": "target",
          "type": "string",
          "required": true,
          "description": "State path to write grouped rows"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": true
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/groupBy",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": true,
        "ssr": true
      },
      "generationPolicy": "allow",
      "grounding": "table-mutation",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "immediate"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "groupBy",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:groupBy:keyField",
            "path": "keyField",
            "required": true,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:groupBy:keySlice",
            "path": "keySlice",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:groupBy:source",
            "path": "source",
            "required": true,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:groupBy:sumFields",
            "path": "sumFields",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:groupBy:target",
            "path": "target",
            "required": true,
            "role": "target"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:groupBy:sha256:5e680edc286f76bc1908e751533aa390759ed7860011a389f683935f75cfda7b",
            "kind": "state-target",
            "targetParam": "target"
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [],
        "missingConsumerPolicy": "reject-before-side-effects"
      }
    },
    {
      "name": "invokeCallback",
      "category": "ui",
      "label": "Invoke Callback",
      "description": "Invoke a host-registered block callback by name.",
      "params": [],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [
        "callback",
        "callback_action"
      ],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/invokeCallback",
      "lifecycle": "active",
      "registryExposure": "runtime-only",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "host-only",
      "grounding": "host-callback",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "event",
        "atomic": true,
        "completion": "accepted"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "invokeCallback",
        "runtimeAliases": [
          "callback",
          "callback_action"
        ],
        "reads": [
          {
            "aliases": [
              "params"
            ],
            "channelId": "parameter-channel:invokeCallback:args",
            "path": "args",
            "required": false,
            "role": "payload"
          },
          {
            "aliases": [
              "callbackId"
            ],
            "channelId": "parameter-channel:invokeCallback:callback",
            "path": "callback",
            "required": true,
            "role": "selector"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:invokeCallback:sha256:2b43c6b4aa43c257c053549c4ca0b24d473dd3fc4fb8baebee21af8f511ccc64",
            "kind": "host-registry",
            "capabilityId": "host.callback",
            "selectorParam": "callback",
            "payloadParam": "args"
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:invokeCallback:sha256:21dfb056e765d2d77ee1909377967462375530b9ed30eb0cf84f0a43b06b6507",
            "capabilityId": "host.callback",
            "operation": "invoke"
          }
        ],
        "requiredHostCapabilities": [
          "host.callback"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "invokeNativeSignatureAgent",
      "category": "auth",
      "label": "Invoke Native Signature Agent",
      "description": "Invoke a native authentication/signature agent installed on the device — the general category for a locally-installed native application holding a user credential (for example, a certificate-based electronic-signature application) that performs an authentication or signing operation no in-browser code can perform directly. method:\"load\" checks whether the host-configured agent is installed and ready; method:\"sign\" asks it to produce a signature over `payload`. The ontology names no vendor: `agentRef` selects which registered native agent to target, so a different vendor's agent is expressed by configuring a new agentRef value at the host, not by adding a new action. See docs/agentic/ontology/native-signature-agent-adapter-contract.md for the full adapter contract this entry commits the runtime to.",
      "params": [
        {
          "name": "method",
          "type": "string",
          "required": true,
          "enumValues": [
            "load",
            "sign"
          ],
          "description": "load | sign — which native signature-agent operation to invoke."
        },
        {
          "name": "agentRef",
          "type": "string",
          "description": "Host-configured identifier selecting which registered native signature agent to target when more than one is configured. Vendor-neutral — the ontology names no vendor."
        },
        {
          "name": "payload",
          "type": "expression",
          "description": "Data to be signed. Used for method:\"sign\"; ignored for method:\"load\"."
        },
        {
          "name": "resultTarget",
          "type": "string",
          "description": "State path to store the agent's result: { type: \"success\" | \"cancel\" | \"error\", signature?: string, available?: boolean }."
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/invokeNativeSignatureAgent",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "adapter-only",
      "grounding": "native-adapter",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
        "docs/agentic/ontology/native-signature-agent-adapter-contract.md",
        "gridone/wonbanking/reports/scope1/SCOPE-1-operator-decision.md",
        "docs/strategy/cogo-decision-batch-2026-08-06.md"
      ],
      "securityClass": "sensitive",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "invokeNativeSignatureAgent",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:invokeNativeSignatureAgent:agentRef",
            "path": "agentRef",
            "required": false,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:invokeNativeSignatureAgent:method",
            "path": "method",
            "required": true,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:invokeNativeSignatureAgent:payload",
            "path": "payload",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:invokeNativeSignatureAgent:resultTarget",
            "path": "resultTarget",
            "required": false,
            "role": "target"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:invokeNativeSignatureAgent:sha256:e17e8580a461db1ee27e2733c113a2b794f4a833d162a2c6c57b95b32ba05814",
            "kind": "host-effect",
            "capabilityId": "host.native-signature-agent",
            "operation": "invoke"
          },
          {
            "channelId": "result-channel:invokeNativeSignatureAgent:sha256:296350bdc75d159e6d4d57cb9d4e84cb8fbc93c6437fc2fdb64582d30953f24a",
            "kind": "state-target",
            "targetParam": "resultTarget",
            "defaultTarget": "_results.nativeSignatureAgent"
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:invokeNativeSignatureAgent:sha256:cf28472c952c23b622631812e550da138acc4974a027107ac1d7dba765978bff",
            "capabilityId": "host.native-signature-agent",
            "operation": "invoke"
          }
        ],
        "requiredHostCapabilities": [
          "host.native-signature-agent"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "jsonExport",
      "category": "data",
      "label": "Json Export",
      "description": "Export data as JSON.",
      "params": [],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": true
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/jsonExport",
      "lifecycle": "active",
      "registryExposure": "runtime-only",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": true
      },
      "generationPolicy": "allow",
      "grounding": "export",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "immediate"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "jsonExport",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:jsonExport:data",
            "path": "data",
            "required": true,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:jsonExport:filename",
            "path": "filename",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:jsonExport:resultTarget",
            "path": "resultTarget",
            "required": false,
            "role": "target"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:jsonExport:sha256:a757c16dc5cbb93c2e907d4e6ae80e2abc26a041c16a86e80fd4adb14fd9d7f8",
            "kind": "host-effect",
            "capabilityId": "host.download",
            "operation": "json"
          },
          {
            "channelId": "result-channel:jsonExport:sha256:4e60b88efabffaca96f7d7bea8a53e62cf0fd024936d5d6928b97fac13d0dc94",
            "kind": "state-target",
            "targetParam": "resultTarget",
            "defaultTarget": "_results.jsonExport"
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:jsonExport:sha256:be81485a715f2093509c7f94b89a768d37a770fc07a8931bb097e8e231b5685b",
            "capabilityId": "host.download",
            "operation": "json"
          }
        ],
        "requiredHostCapabilities": [
          "host.download"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "loadDatasource",
      "category": "data",
      "label": "Load Datasource",
      "description": "Resolve a named datasource through the injected DataSourceManager.",
      "params": [],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": true
      },
      "aliases": [
        "loadDataSource"
      ],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/loadDatasource",
      "lifecycle": "active",
      "registryExposure": "runtime-only",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": true
      },
      "generationPolicy": "adapter-only",
      "grounding": "datasource-adapter",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "loadDatasource",
        "runtimeAliases": [
          "loadDataSource"
        ],
        "reads": [
          {
            "channelId": "parameter-channel:loadDatasource:body",
            "path": "body",
            "required": false,
            "role": "payload"
          },
          {
            "aliases": [
              "source"
            ],
            "channelId": "parameter-channel:loadDatasource:datasourceId",
            "path": "datasourceId",
            "required": true,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:loadDatasource:method",
            "path": "method",
            "required": false,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:loadDatasource:query",
            "path": "query",
            "required": false,
            "role": "payload"
          },
          {
            "aliases": [
              "target"
            ],
            "channelId": "parameter-channel:loadDatasource:resultTarget",
            "path": "resultTarget",
            "required": false,
            "role": "target"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:loadDatasource:sha256:c7e5e89e0c5e00c9c70109fd28fe919e517267560d534d948983f4c25988d245",
            "kind": "host-effect",
            "capabilityId": "host.datasource",
            "operation": "load"
          },
          {
            "channelId": "result-channel:loadDatasource:sha256:cfa477a83e214c8089a53ed6b0f1b8ef3c0729ade8233b071fd27086dcec6287",
            "kind": "state-target",
            "targetParam": "resultTarget"
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:loadDatasource:sha256:a66c15243921e6f0ee497f724bdf9c26aca461f208f45b89bc01aa4d96a81a43",
            "capabilityId": "host.datasource",
            "operation": "load"
          }
        ],
        "requiredHostCapabilities": [
          "host.datasource"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "log",
      "category": "state",
      "label": "Console Log",
      "description": "Log a value to the developer console",
      "params": [
        {
          "name": "message",
          "type": "expression"
        },
        {
          "name": "level",
          "type": "string",
          "default": "log"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": true
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/log",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": true
      },
      "generationPolicy": "allow",
      "grounding": "generated",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "immediate"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "log",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:log:data",
            "path": "data",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:log:level",
            "path": "level",
            "required": false,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:log:message",
            "path": "message",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:log:value",
            "path": "value",
            "required": false,
            "role": "payload"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:log:sha256:5e5c0f0ba23ca781faebfa7879865b77de79c8ab7dd9f0b38f9aaa702e4793c7",
            "kind": "host-effect",
            "capabilityId": "host.console",
            "operation": "log"
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:log:sha256:b150cf183fbb98dba2b860ace3f6f03858f2f10c4fbdff867d7a62e2737a32a6",
            "capabilityId": "host.console",
            "operation": "log"
          }
        ],
        "requiredHostCapabilities": [
          "host.console"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "mediaCapture",
      "category": "media",
      "label": "Media Capture",
      "description": "Capture photo or video from camera",
      "params": [
        {
          "name": "type",
          "type": "string",
          "default": "photo",
          "description": "photo | video"
        },
        {
          "name": "resultPath",
          "type": "string"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/mediaCapture",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "adapter-only",
      "grounding": "native-adapter",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "system",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "mediaCapture",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:mediaCapture:audio",
            "path": "audio",
            "required": false,
            "role": "guard"
          },
          {
            "channelId": "parameter-channel:mediaCapture:maxDuration",
            "path": "maxDuration",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:mediaCapture:quality",
            "path": "quality",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:mediaCapture:resultPath",
            "path": "resultPath",
            "required": false,
            "role": "target"
          },
          {
            "channelId": "parameter-channel:mediaCapture:source",
            "path": "source",
            "required": false,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:mediaCapture:type",
            "path": "type",
            "required": false,
            "role": "selector"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:mediaCapture:sha256:6dbf45b312dffd09ac5e951358f2991a8b0c9efddd90b6ead6f395f70b3ec4a5",
            "kind": "host-effect",
            "capabilityId": "host.media",
            "operation": "capture"
          },
          {
            "channelId": "result-channel:mediaCapture:sha256:70602f4574b0b42309b1585925c198b233ef44ac4199aa87699faad74a4d5f58",
            "kind": "state-target",
            "targetParam": "resultPath",
            "defaultTarget": "_results.media"
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:mediaCapture:sha256:e510273d0941dad0c7b2de43a2c77b5768506a4c8c8280f405597ea33bd51cef",
            "capabilityId": "host.media",
            "operation": "capture"
          }
        ],
        "requiredHostCapabilities": [
          "host.media"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "mediaControl",
      "category": "media",
      "label": "Media Control",
      "description": "Control a host media element: play, pause, seek, volume, fullscreen.",
      "params": [],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/mediaControl",
      "lifecycle": "active",
      "registryExposure": "runtime-only",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "adapter-only",
      "grounding": "media-adapter",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "system",
        "atomic": true,
        "completion": "immediate"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "mediaControl",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:mediaControl:$",
            "path": "$",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:mediaControl:command",
            "path": "command",
            "required": true,
            "role": "selector"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:mediaControl:sha256:f13e0545cdcb840e991d93d57ed408c012e659fe5a63c36b0ade75371a291639",
            "kind": "host-effect",
            "capabilityId": "host.media",
            "operation": "control"
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:mediaControl:sha256:f13f4f066b3c4ca540086792a9f4a588a82d10a55d0ddd8fd85b4fc6c067115a",
            "capabilityId": "host.media",
            "operation": "control"
          }
        ],
        "requiredHostCapabilities": [
          "host.media"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "navigate",
      "category": "navigation",
      "label": "Navigate",
      "description": "Navigate to a route within the app",
      "params": [
        {
          "name": "route",
          "type": "string",
          "required": true
        },
        {
          "name": "mode",
          "type": "string",
          "default": "push",
          "description": "push | replace"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/navigate",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "allow",
      "grounding": "generated",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "navigation",
        "atomic": true,
        "completion": "accepted"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "navigate",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:navigate:mode",
            "path": "mode",
            "required": false,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:navigate:params",
            "path": "params",
            "required": false,
            "role": "payload"
          },
          {
            "aliases": [
              "route",
              "target"
            ],
            "channelId": "parameter-channel:navigate:to",
            "path": "to",
            "required": true,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:navigate:transition",
            "path": "transition",
            "required": false,
            "role": "input"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:navigate:sha256:2151bc55ade9830b0f8a14a5cf4a925cb79cdd4bcb9f055bec16244c4fee2c1c",
            "kind": "host-effect",
            "when": {
              "param": "mode",
              "equals": [
                "replace"
              ]
            },
            "capabilityId": "host.navigation",
            "operation": "replace"
          },
          {
            "channelId": "result-channel:navigate:sha256:4ae807492650a85d868c8c47827b770335b0f30b3a7495c3609330f7f022c214",
            "kind": "host-effect",
            "capabilityId": "host.navigation",
            "operation": "push"
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:navigate:sha256:6cd3f9fc53bc43cc8bfa4f64ca2846c3347f9d21331d4d8d80aaad6926f38192",
            "capabilityId": "host.navigation",
            "operation": "push"
          },
          {
            "channelId": "host-channel:navigate:sha256:9828a0ea4ace451e3a88dd49ca75ab04fc2242125bed7c20c34eeb060991a4ef",
            "capabilityId": "host.navigation",
            "operation": "replace",
            "when": {
              "param": "mode",
              "equals": [
                "replace"
              ]
            }
          }
        ],
        "requiredHostCapabilities": [
          "host.navigation"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "notification",
      "category": "system",
      "label": "Notification",
      "description": "Show a system notification",
      "params": [
        {
          "name": "title",
          "type": "string",
          "required": true
        },
        {
          "name": "body",
          "type": "string"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/notification",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "allow",
      "grounding": "generated",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "sensitive",
      "semantics": {
        "domain": "system",
        "atomic": true,
        "completion": "immediate"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "notification",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:notification:body",
            "path": "body",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:notification:title",
            "path": "title",
            "required": true,
            "role": "input"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:notification:sha256:42b086bb009a6562c4df095fcf5d721acb67f11939c6b6a3a61ba730cccb2ea5",
            "kind": "host-effect",
            "capabilityId": "host.notification",
            "operation": "show"
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:notification:sha256:2dc44d6003786820676d7fcdaeaea01dfe928f69b761c83a0b6f9436edc8bf9a",
            "capabilityId": "host.notification",
            "operation": "show"
          }
        ],
        "requiredHostCapabilities": [
          "host.notification"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "openAuthSession",
      "category": "auth",
      "label": "Open Auth Session",
      "description": "Open an OAuth/SSO auth session in an in-app browser. On RN uses expo-web-browser openAuthSessionAsync. On web falls back to window.open popup.",
      "params": [
        {
          "name": "url",
          "type": "string",
          "required": true,
          "description": "OAuth authorization URL"
        },
        {
          "name": "redirectUrl",
          "type": "string",
          "description": "Redirect URL to capture auth callback"
        },
        {
          "name": "resultTarget",
          "type": "string",
          "description": "State path to store the returned URL with tokens"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/openAuthSession",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "allow",
      "grounding": "native-adapter",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "sensitive",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "openAuthSession",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:openAuthSession:redirectUrl",
            "path": "redirectUrl",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:openAuthSession:resultTarget",
            "path": "resultTarget",
            "required": false,
            "role": "target"
          },
          {
            "channelId": "parameter-channel:openAuthSession:url",
            "path": "url",
            "required": true,
            "role": "input"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:openAuthSession:sha256:9863e9e9712752e8b4094ec292633dc275332107221b744b5478e44ea4e88228",
            "kind": "host-effect",
            "capabilityId": "host.auth-session",
            "operation": "open"
          },
          {
            "channelId": "result-channel:openAuthSession:sha256:3273ed7786f42f8550b811d5879423d01aaebbcbc7348d350c8f8b69ced4c37e",
            "kind": "state-target",
            "targetParam": "resultTarget",
            "defaultTarget": "_results.auth"
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:openAuthSession:sha256:7da989ae9ff0ff980091cf8339be5efcac49da4f55b1f055dd66b41a505ae9d7",
            "capabilityId": "host.auth-session",
            "operation": "open"
          }
        ],
        "requiredHostCapabilities": [
          "host.auth-session"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "openModal",
      "category": "ui",
      "label": "Open Modal",
      "description": "Open a host-registered modal by id.",
      "params": [],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/openModal",
      "lifecycle": "active",
      "registryExposure": "runtime-only",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "host-only",
      "grounding": "host-callback",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "ui",
        "atomic": true,
        "completion": "accepted"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "openModal",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:openModal:$",
            "path": "$",
            "required": false,
            "role": "payload"
          },
          {
            "aliases": [
              "popup"
            ],
            "channelId": "parameter-channel:openModal:modalId",
            "path": "modalId",
            "required": true,
            "role": "selector"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:openModal:sha256:d3f8cbf33caf931a6842464bc1f581435c0fc83fed4a4b539565d2136ddcc932",
            "kind": "host-effect",
            "capabilityId": "host.modal",
            "operation": "open"
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:openModal:sha256:51808fbad2b06db48792fb314061a49207063fc90e33b8f987ddb716c4790131",
            "capabilityId": "host.modal",
            "operation": "open"
          }
        ],
        "requiredHostCapabilities": [
          "host.modal"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "openNativeFilePicker",
      "category": "system",
      "label": "Open Native File Picker",
      "description": "Runtime alias for pickFiles used by native flows.",
      "params": [],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": "pickFiles",
      "ontologyIri": "https://cogo.xyz/instances/action/openNativeFilePicker",
      "lifecycle": "active",
      "registryExposure": "runtime-only",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "alias-only",
      "grounding": "alias",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "sensitive",
      "semantics": {
        "domain": "system",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "openNativeFilePicker",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:openNativeFilePicker:accept",
            "path": "accept",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:openNativeFilePicker:multiple",
            "path": "multiple",
            "required": false,
            "role": "guard"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:openNativeFilePicker:sha256:f7bf483d63fe110a0226a778d1ef2d2bed05705446ab0c3ca509b019e68acddb",
            "kind": "host-effect",
            "capabilityId": "host.file-picker",
            "operation": "open-native"
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:openNativeFilePicker:sha256:7235aea9f5ede7d18f02165dad3746b53dbf622dbf1485e7a629ccf3b5a326a3",
            "capabilityId": "host.file-picker",
            "operation": "open-native"
          }
        ],
        "requiredHostCapabilities": [
          "host.file-picker"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "payment",
      "category": "system",
      "label": "Payment",
      "description": "Process a payment",
      "params": [
        {
          "name": "provider",
          "type": "string",
          "required": true
        },
        {
          "name": "amount",
          "type": "number",
          "required": true
        },
        {
          "name": "currency",
          "type": "string",
          "default": "USD"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/payment",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "adapter-only",
      "grounding": "payment-adapter",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "sensitive",
      "semantics": {
        "domain": "system",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "payment",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:payment:$",
            "path": "$",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:payment:resultTarget",
            "path": "resultTarget",
            "required": false,
            "role": "target"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:payment:sha256:146242be8facc0968560b31a8cb2e32cec578853dbbedd0d6f28c951cc539e53",
            "kind": "host-effect",
            "capabilityId": "host.payment",
            "operation": "invoke"
          },
          {
            "channelId": "result-channel:payment:sha256:10f9620df5af8d2f3fb1dc75af1204b39072fc76abb2992529b0811d4e951a01",
            "kind": "state-target",
            "targetParam": "resultTarget",
            "defaultTarget": "_results.payment"
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:payment:sha256:f84a27b7316f60ca17c264ba3a86a84fff10740234a6f177c2d7a546f27c288b",
            "capabilityId": "host.payment",
            "operation": "invoke"
          }
        ],
        "requiredHostCapabilities": [
          "host.payment"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "pickFiles",
      "category": "system",
      "label": "Pick Files",
      "description": "Open a file picker and write selected file metadata to state.",
      "params": [],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/pickFiles",
      "lifecycle": "active",
      "registryExposure": "runtime-only",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "adapter-only",
      "grounding": "native-adapter",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "sensitive",
      "semantics": {
        "domain": "system",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "pickFiles",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:pickFiles:accept",
            "path": "accept",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:pickFiles:multiple",
            "path": "multiple",
            "required": false,
            "role": "guard"
          },
          {
            "aliases": [
              "resultTarget"
            ],
            "channelId": "parameter-channel:pickFiles:resultPath",
            "path": "resultPath",
            "required": false,
            "role": "target"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:pickFiles:sha256:b8fe01ffcecd3d70286ad8ea44399aff0f5516726281525a118cf0ea230cd7f2",
            "kind": "host-effect",
            "capabilityId": "host.file-picker",
            "operation": "pick"
          },
          {
            "channelId": "result-channel:pickFiles:sha256:d439926e83b56b1185de39e807c9e939b9adf010edef29a6e90f78bc8435d80e",
            "kind": "state-target",
            "targetParam": "resultPath",
            "defaultTarget": "_results.pickFiles"
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:pickFiles:sha256:25f78897f9cfad0b5c842a2db4d679ef7339e79fa9251b46badeeb6d3fb06b72",
            "capabilityId": "host.file-picker",
            "operation": "pick"
          }
        ],
        "requiredHostCapabilities": [
          "host.file-picker"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "printAction",
      "category": "system",
      "label": "Print",
      "description": "Open the print dialog",
      "params": [],
      "platform": {
        "web": true,
        "reactNative": false,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/printAction",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": false,
        "flutter": false,
        "ssr": false
      },
      "generationPolicy": "allow",
      "grounding": "generated",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "sensitive",
      "semantics": {
        "domain": "system",
        "atomic": true,
        "completion": "immediate"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "printAction",
        "runtimeAliases": [],
        "reads": [],
        "resultChannels": [
          {
            "channelId": "result-channel:printAction:sha256:28416bec959d2bbb0521a7abf7184e377b2f4377366f3e41e39b0fd0a4e0b893",
            "kind": "host-effect",
            "capabilityId": "host.print",
            "operation": "print"
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:printAction:sha256:72adbb8f79e2da4cc3dbf0799bc359afd63728af1997a21ffa869731d937db20",
            "capabilityId": "host.print",
            "operation": "print"
          }
        ],
        "requiredHostCapabilities": [
          "host.print"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "queueAction",
      "category": "flow",
      "label": "Queue Action",
      "description": "Queue an action for sequential execution",
      "params": [
        {
          "name": "queueId",
          "type": "string",
          "required": true
        },
        {
          "name": "action",
          "type": "string",
          "required": true
        },
        {
          "name": "params",
          "type": "object"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": true
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/queueAction",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": true
      },
      "generationPolicy": "allow",
      "grounding": "control-flow",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "business",
        "atomic": false,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "queueAction",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:queueAction:action",
            "path": "action",
            "required": true,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:queueAction:params",
            "path": "params",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:queueAction:priority",
            "path": "priority",
            "required": false,
            "role": "input"
          },
          {
            "aliases": [
              "queueId"
            ],
            "channelId": "parameter-channel:queueAction:queue",
            "path": "queue",
            "required": false,
            "role": "selector"
          }
        ],
        "resultChannels": [],
        "hostCapabilities": [],
        "requiredHostCapabilities": [],
        "missingConsumerPolicy": "reject-before-side-effects"
      }
    },
    {
      "name": "realtimeSync",
      "category": "network",
      "label": "Realtime Sync (Deprecated)",
      "description": "Subscribe to server-sent events. Use supabaseRealtime instead.",
      "deprecated": true,
      "replacedBy": "supabaseRealtime",
      "deprecatedMessage": "realtimeSync uses EventSource SSE. Migrate to supabaseRealtime for postgres_changes, broadcast, and presence support.",
      "params": [
        {
          "name": "url",
          "type": "string",
          "required": true
        },
        {
          "name": "resultPath",
          "type": "string"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": false,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": "supabaseRealtime",
      "ontologyIri": "https://cogo.xyz/instances/action/realtimeSync",
      "lifecycle": "deprecated",
      "registryExposure": "public",
      "runtimeImplemented": false,
      "targetSupport": {
        "web": true,
        "reactNative": false,
        "flutter": false,
        "ssr": false
      },
      "generationPolicy": "alias-only",
      "grounding": "generated",
      "evidence": [
        "packages/cogo-action-registry/src/registry.ts"
      ],
      "securityClass": "sensitive",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "completed"
      }
    },
    {
      "name": "removeWhere",
      "category": "data",
      "label": "Remove Where",
      "description": "Remove every array row the predicate matches.",
      "params": [
        {
          "name": "target",
          "type": "string",
          "required": true,
          "description": "Bare state path of the array to delete from (runtime reads params.target)"
        },
        {
          "name": "predicate",
          "type": "expression",
          "required": true,
          "description": "Bare arrow predicate (e.g. \"item => item.id === '#{event.itemId}'\") identifying rows to delete"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/removeWhere",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "allow",
      "grounding": "generated",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "immediate"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "removeWhere",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:removeWhere:$",
            "path": "$",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:removeWhere:target",
            "path": "target",
            "required": true,
            "role": "target"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:removeWhere:sha256:5e680edc286f76bc1908e751533aa390759ed7860011a389f683935f75cfda7b",
            "kind": "state-target",
            "targetParam": "target"
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [],
        "missingConsumerPolicy": "reject-before-side-effects"
      }
    },
    {
      "name": "restApi",
      "category": "network",
      "label": "REST API",
      "description": "Make an HTTP request to a REST API. The response lands at the state path named by `resultTarget` — the ONE canonical result-key name.",
      "params": [
        {
          "name": "url",
          "type": "string",
          "required": true
        },
        {
          "name": "method",
          "type": "string",
          "default": "GET"
        },
        {
          "name": "headers",
          "type": "object"
        },
        {
          "name": "body",
          "type": "object"
        },
        {
          "name": "resultTarget",
          "type": "string",
          "description": "State path the response is written to. CANONICAL result-key name for restApi — action-flow-engine.ts:1977 reads `params.resultTarget ?? params.target ?? params.responseKey` (plus a legacy `resultKey` it re-prefixes with `_results.`). It was spelled `resultPath` here until Task 4 (authority-repair, 2026-08-08); no runtime reads `params.resultPath` for restApi, so that spelling silently dropped every response. Not the step-level `key` either: actionRestApi returns void, so `_results.<step.name>` auto-capture never fires — write `resultTarget: \"_results.<name>\"` for a downstream `#{_results.<name>...}` read."
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": true
      },
      "aliases": [
        "restful_data_action"
      ],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/restApi",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": "adapter"
      },
      "generationPolicy": "adapter-only",
      "grounding": "network-adapter",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "sensitive",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "restApi",
        "runtimeAliases": [
          "restful_data_action"
        ],
        "reads": [
          {
            "channelId": "parameter-channel:restApi:body",
            "path": "body",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:restApi:credentials",
            "path": "credentials",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:restApi:headers",
            "path": "headers",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:restApi:method",
            "path": "method",
            "required": false,
            "role": "selector"
          },
          {
            "aliases": [
              "responseKey",
              "resultKey",
              "target"
            ],
            "channelId": "parameter-channel:restApi:resultTarget",
            "path": "resultTarget",
            "required": false,
            "role": "target"
          },
          {
            "channelId": "parameter-channel:restApi:retryPolicy",
            "path": "retryPolicy",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:restApi:throwOnHttpError",
            "path": "throwOnHttpError",
            "required": false,
            "role": "guard"
          },
          {
            "channelId": "parameter-channel:restApi:timeout",
            "path": "timeout",
            "required": false,
            "role": "input"
          },
          {
            "aliases": [
              "endpoint"
            ],
            "channelId": "parameter-channel:restApi:url",
            "path": "url",
            "required": true,
            "role": "input"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:restApi:sha256:a1d9f94e51e4ea640bfc13d79d8c0d2222d5597a85c3bec6e4d2d9c5591ba7c4",
            "kind": "state-target",
            "targetParam": "resultTarget",
            "envelope": {
              "kind": "object",
              "properties": {
                "count": {
                  "kind": "unknown"
                },
                "data": {
                  "kind": "unknown"
                },
                "status": {
                  "kind": "scalar",
                  "type": "number"
                }
              },
              "required": [
                "data",
                "status"
              ]
            }
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [
          "host.fetch"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "retryAction",
      "category": "flow",
      "label": "Retry Action",
      "description": "Retry an action with exponential backoff",
      "params": [
        {
          "name": "action",
          "type": "string",
          "required": true
        },
        {
          "name": "params",
          "type": "object"
        },
        {
          "name": "maxRetries",
          "type": "number",
          "default": 3
        },
        {
          "name": "baseDelay",
          "type": "number",
          "default": 1000
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": true
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/retryAction",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": true
      },
      "generationPolicy": "allow",
      "grounding": "control-flow",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "business",
        "atomic": false,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "retryAction",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:retryAction:action",
            "path": "action",
            "required": true,
            "role": "selector"
          },
          {
            "aliases": [
              "baseDelay"
            ],
            "channelId": "parameter-channel:retryAction:delay",
            "path": "delay",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:retryAction:maxRetries",
            "path": "maxRetries",
            "required": false,
            "role": "guard"
          },
          {
            "channelId": "parameter-channel:retryAction:params",
            "path": "params",
            "required": false,
            "role": "payload"
          }
        ],
        "resultChannels": [],
        "hostCapabilities": [],
        "requiredHostCapabilities": [],
        "missingConsumerPolicy": "reject-before-side-effects"
      }
    },
    {
      "name": "runMotion",
      "category": "ui",
      "label": "Run Motion",
      "description": "Run a host animation on a rendered element and wait for its completion before the next ActionFlow step.",
      "params": [
        {
          "name": "target",
          "type": "string",
          "required": true,
          "description": "Cogo element id (data-cogo-element-id) to animate."
        },
        {
          "name": "preset",
          "type": "string",
          "required": true,
          "enumValues": [
            "fade-in",
            "fade-out",
            "slide-in",
            "slide-out",
            "scale-in",
            "scale-out",
            "pulse"
          ],
          "description": "fade-in | fade-out | slide-in | slide-out | scale-in | scale-out | pulse"
        },
        {
          "name": "durationMs",
          "type": "number",
          "default": 200
        },
        {
          "name": "easing",
          "type": "string",
          "default": "ease-out"
        },
        {
          "name": "fill",
          "type": "string",
          "default": "both",
          "enumValues": [
            "none",
            "forwards",
            "backwards",
            "both"
          ],
          "description": "none | forwards | backwards | both"
        },
        {
          "name": "reducedMotion",
          "type": "string",
          "default": "instant",
          "enumValues": [
            "instant",
            "skip"
          ],
          "description": "instant | skip when prefers-reduced-motion is active"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": false,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/runMotion",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": false,
        "flutter": false,
        "ssr": false
      },
      "generationPolicy": "allow",
      "grounding": "host-callback",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-react-renderer-v2/src/host/motion-registry.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "motion",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "runMotion",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:runMotion:$",
            "path": "$",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:runMotion:preset",
            "path": "preset",
            "required": true,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:runMotion:target",
            "path": "target",
            "required": true,
            "role": "input"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:runMotion:sha256:cd94e04f86bc635f2194e48e15ffb2cb46af58c246601be011bb1701c502d69e",
            "kind": "host-effect",
            "capabilityId": "host.motion",
            "operation": "run"
          },
          {
            "channelId": "result-channel:runMotion:sha256:1182f31e9f03c5704bab18950e9381188a2a4411c1380c47c4fce875f9383d02",
            "kind": "return-capture",
            "capture": "step-name"
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:runMotion:sha256:f232724b7f8471e90257b07dc9fda7bfd0e916fd7e33cbad7204007a48907537",
            "capabilityId": "host.motion",
            "operation": "run"
          }
        ],
        "requiredHostCapabilities": [
          "host.motion"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "scrollTo",
      "category": "ui",
      "label": "Scroll To",
      "description": "Scroll to an element or position",
      "params": [
        {
          "name": "target",
          "type": "string",
          "description": "Element ID or pixel offset"
        },
        {
          "name": "smooth",
          "type": "boolean",
          "default": true
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "deprecated": true,
      "replacedBy": "scrollToElement",
      "deprecatedMessage": "scrollTo has no runtime-v2 executor; use scrollToElement (element/sectionId) or scrollToPosition (y offset).",
      "aliases": [],
      "canonicalAction": "scrollToElement",
      "ontologyIri": "https://cogo.xyz/instances/action/scrollTo",
      "lifecycle": "deprecated",
      "registryExposure": "public",
      "runtimeImplemented": false,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "alias-only",
      "grounding": "generated",
      "evidence": [
        "packages/cogo-action-registry/src/registry.ts"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "ui",
        "atomic": true,
        "completion": "immediate"
      }
    },
    {
      "name": "scrollToElement",
      "category": "ui",
      "label": "Scroll To Element",
      "description": "Scroll the viewport to a target element by ID.",
      "params": [
        {
          "name": "target",
          "type": "string",
          "description": "Element ID to scroll to"
        },
        {
          "name": "sectionId",
          "type": "string",
          "description": "Alternative section ID"
        },
        {
          "name": "behavior",
          "type": "string",
          "description": "'smooth' | 'auto'"
        },
        {
          "name": "smooth",
          "type": "boolean",
          "default": true
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/scrollToElement",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "allow",
      "grounding": "generated",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "ui",
        "atomic": true,
        "completion": "immediate"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "scrollToElement",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:scrollToElement:behavior",
            "path": "behavior",
            "required": false,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:scrollToElement:smooth",
            "path": "smooth",
            "required": false,
            "role": "guard"
          },
          {
            "aliases": [
              "sectionId"
            ],
            "channelId": "parameter-channel:scrollToElement:target",
            "path": "target",
            "required": true,
            "role": "input"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:scrollToElement:sha256:7bf782b55d2d93b699782252c6d7b058986a428d5ada06d0f2cfbda0a5e05c7d",
            "kind": "host-effect",
            "capabilityId": "host.scroll",
            "operation": "element"
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:scrollToElement:sha256:653a924a6455fab143804ed59f14c2381bc9293041e889d14c114170339f5991",
            "capabilityId": "host.scroll",
            "operation": "element"
          }
        ],
        "requiredHostCapabilities": [
          "host.scroll"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "scrollToPosition",
      "category": "ui",
      "label": "Scroll To Position",
      "description": "Scroll the viewport to a vertical pixel offset.",
      "params": [
        {
          "name": "y",
          "type": "number",
          "description": "Vertical pixel offset"
        },
        {
          "name": "behavior",
          "type": "string",
          "description": "'smooth' | 'auto'"
        },
        {
          "name": "smooth",
          "type": "boolean",
          "default": true
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/scrollToPosition",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "allow",
      "grounding": "generated",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "ui",
        "atomic": true,
        "completion": "immediate"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "scrollToPosition",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:scrollToPosition:behavior",
            "path": "behavior",
            "required": false,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:scrollToPosition:smooth",
            "path": "smooth",
            "required": false,
            "role": "guard"
          },
          {
            "channelId": "parameter-channel:scrollToPosition:y",
            "path": "y",
            "required": false,
            "role": "input"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:scrollToPosition:sha256:4fcad99b04f240deb57bdde2f5797a6b6d2d29af41d117ce6541f8aefdd4b8d2",
            "kind": "host-effect",
            "capabilityId": "host.scroll",
            "operation": "position"
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:scrollToPosition:sha256:2cfc37b4eca4a7413fb2ec2827a875867d904a3c77244e27b62547450c9bd436",
            "capabilityId": "host.scroll",
            "operation": "position"
          }
        ],
        "requiredHostCapabilities": [
          "host.scroll"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "setState",
      "category": "state",
      "label": "Set State",
      "description": "Set a state variable to a value",
      "params": [
        {
          "name": "path",
          "type": "string",
          "description": "Legacy/unused param name — the runtime does not read params.path for setState (action-flow-engine.ts#actionSetState reads params.target exclusively, in both cogo-runtime-v2 and the deprecated-frozen v1 cogo-runtime-core). Kept only so pre-existing content that happens to carry this key still validates; do not generate it."
        },
        {
          "name": "value",
          "type": "expression",
          "required": true,
          "description": "Value to set (can be expression)"
        },
        {
          "name": "target",
          "type": "string",
          "required": true,
          "description": "Dot-path to the state variable to write. The ONLY param the runtime reads for setState (genquality census 2026-08-07 defect 3 — see action-flow-engine.ts#actionSetState doc comment: \"strict target only (no path alias)\")."
        },
        {
          "name": "operation",
          "type": "string",
          "description": "Sub-operation: append | upsert | removeWhere | updateWhere (default: replace value)"
        },
        {
          "name": "predicate",
          "type": "expression",
          "description": "Bare arrow predicate (e.g. \"item => item.id === '#{event.itemId}'\") for operation=removeWhere | updateWhere"
        },
        {
          "name": "match",
          "type": "expression",
          "description": "Bare arrow predicate for operation=upsert (engine-canonical name)"
        },
        {
          "name": "matchExpr",
          "type": "expression",
          "description": "Bare arrow predicate for operation=upsert (corpus-alias accepted by upsertWhere alias dispatch)"
        },
        {
          "name": "onMatch",
          "type": "object",
          "description": "Column-value dictionary applied when match/matchExpr finds a row (operation=upsert)"
        },
        {
          "name": "onNew",
          "type": "object",
          "description": "Column-value dictionary used when no row matches (operation=upsert)"
        },
        {
          "name": "update",
          "type": "object",
          "description": "Column-value dictionary applied to predicated rows (operation=updateWhere)"
        },
        {
          "name": "updates",
          "type": "object",
          "description": "Corpus-alias for update (consumed by updateWhere alias dispatch)"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": true
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/setState",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": true
      },
      "generationPolicy": "allow",
      "grounding": "generated",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "immediate"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "setState",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:setState:match",
            "path": "match",
            "required": false,
            "role": "guard"
          },
          {
            "channelId": "parameter-channel:setState:onMatch",
            "path": "onMatch",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:setState:onNew",
            "path": "onNew",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:setState:operation",
            "path": "operation",
            "required": false,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:setState:predicate",
            "path": "predicate",
            "required": false,
            "role": "guard"
          },
          {
            "channelId": "parameter-channel:setState:target",
            "path": "target",
            "required": true,
            "role": "target"
          },
          {
            "channelId": "parameter-channel:setState:update",
            "path": "update",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:setState:value",
            "path": "value",
            "required": false,
            "role": "payload"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:setState:sha256:5e680edc286f76bc1908e751533aa390759ed7860011a389f683935f75cfda7b",
            "kind": "state-target",
            "targetParam": "target"
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [],
        "missingConsumerPolicy": "reject-before-side-effects"
      }
    },
    {
      "name": "setTableCell",
      "category": "data",
      "label": "Set Table Cell",
      "description": "Mutate one field on one row in a table/list state array.",
      "params": [
        {
          "name": "target",
          "type": "string",
          "required": true,
          "description": "State path containing the table array"
        },
        {
          "name": "rowIndex",
          "type": "number",
          "required": true,
          "description": "Zero-based row index to update"
        },
        {
          "name": "field",
          "type": "string",
          "required": true,
          "description": "Row field to update"
        },
        {
          "name": "value",
          "type": "expression",
          "required": true,
          "description": "Value to write into the cell"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": true
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/setTableCell",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": true,
        "ssr": true
      },
      "generationPolicy": "allow",
      "grounding": "table-mutation",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "immediate"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "setTableCell",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:setTableCell:field",
            "path": "field",
            "required": true,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:setTableCell:rowIndex",
            "path": "rowIndex",
            "required": true,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:setTableCell:target",
            "path": "target",
            "required": true,
            "role": "target"
          },
          {
            "channelId": "parameter-channel:setTableCell:value",
            "path": "value",
            "required": false,
            "role": "payload"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:setTableCell:sha256:5e680edc286f76bc1908e751533aa390759ed7860011a389f683935f75cfda7b",
            "kind": "state-target",
            "targetParam": "target"
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [],
        "missingConsumerPolicy": "reject-before-side-effects"
      }
    },
    {
      "name": "setTheme",
      "category": "ui",
      "label": "Set Theme",
      "description": "Request a host theme/style scope change.",
      "params": [],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/setTheme",
      "lifecycle": "active",
      "registryExposure": "runtime-only",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "adapter-only",
      "grounding": "host-callback",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "ui",
        "atomic": true,
        "completion": "immediate"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "setTheme",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:setTheme:theme",
            "path": "theme",
            "required": true,
            "role": "selector"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:setTheme:sha256:45ca71b844c98183df37749ccadc54c290e8c03417b893669d9cfcfce573a60f",
            "kind": "host-effect",
            "capabilityId": "host.theme",
            "operation": "set"
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:setTheme:sha256:55d61ad734cff2f94fb6ff009cb49474716b70320ec0a2a2111ebbb8d88b01eb",
            "capabilityId": "host.theme",
            "operation": "set"
          }
        ],
        "requiredHostCapabilities": [
          "host.theme"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "setVariable",
      "category": "state",
      "label": "Set Variable",
      "description": "Set a variable using expression evaluation",
      "params": [
        {
          "name": "name",
          "type": "string",
          "required": true,
          "description": "Variable name to set (bare name, no prefix). The runtime reads params.name first — action-flow-engine.ts#actionSetVariable: `params.name ?? params.target`."
        },
        {
          "name": "value",
          "type": "expression",
          "required": true,
          "description": "Value to set (can be expression)."
        },
        {
          "name": "target",
          "type": "string",
          "description": "Alias for name — the runtime falls back to params.target only when params.name is absent (action-flow-engine.ts#actionSetVariable). Optional; prefer name."
        },
        {
          "name": "scope",
          "type": "string",
          "description": "Optional namespace: 'local' | 'app'/'appData'/'global' | 'computed' | any other value used verbatim as prefix. Omitted ⇒ bare write. Declared in actionflow-executors-v1.ttl#afexec_setVariable (Task 4, alignment-cycle, 2026-08-10 — replaces the fictional required `path` param, which no runtime, executor-TTL, or TBox schema ever declared; see task-4-report.md)."
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": true
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/setVariable",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": true
      },
      "generationPolicy": "allow",
      "grounding": "generated",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "immediate"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "setVariable",
        "runtimeAliases": [],
        "reads": [
          {
            "aliases": [
              "target"
            ],
            "channelId": "parameter-channel:setVariable:name",
            "path": "name",
            "required": true,
            "role": "target"
          },
          {
            "channelId": "parameter-channel:setVariable:scope",
            "path": "scope",
            "required": false,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:setVariable:value",
            "path": "value",
            "required": false,
            "role": "payload"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:setVariable:sha256:ce7f20898e70d2c6f3eecd794971a4ba92bacd964350aa9a2a9221240fbf8bec",
            "kind": "state-target",
            "targetParam": "name"
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [],
        "missingConsumerPolicy": "reject-before-side-effects"
      }
    },
    {
      "name": "shareAction",
      "category": "system",
      "label": "Share",
      "description": "Open the native share dialog",
      "params": [
        {
          "name": "title",
          "type": "string"
        },
        {
          "name": "text",
          "type": "string"
        },
        {
          "name": "url",
          "type": "string"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/shareAction",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "allow",
      "grounding": "generated",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "sensitive",
      "semantics": {
        "domain": "system",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "shareAction",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:shareAction:files",
            "path": "files",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:shareAction:text",
            "path": "text",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:shareAction:title",
            "path": "title",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:shareAction:url",
            "path": "url",
            "required": false,
            "role": "input"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:shareAction:sha256:9826c80e8475d4cc220f15328ef44142ba4702acdb84544851e02a758b073153",
            "kind": "host-effect",
            "capabilityId": "host.share",
            "operation": "share"
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:shareAction:sha256:e4e33a9593312ac2d61011813565a62934e04335a45d5f20c068ac66bd73f86c",
            "capabilityId": "host.share",
            "operation": "share"
          }
        ],
        "requiredHostCapabilities": [
          "host.share"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "showLoading",
      "category": "ui",
      "label": "Show Loading",
      "description": "Show or hide a loading overlay",
      "params": [
        {
          "name": "show",
          "type": "boolean",
          "required": true
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/showLoading",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "allow",
      "grounding": "generated",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "ui",
        "atomic": true,
        "completion": "immediate"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "showLoading",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:showLoading:message",
            "path": "message",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:showLoading:overlay",
            "path": "overlay",
            "required": false,
            "role": "guard"
          },
          {
            "aliases": [
              "value"
            ],
            "channelId": "parameter-channel:showLoading:show",
            "path": "show",
            "required": false,
            "role": "guard"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:showLoading:sha256:34bb04a5d3fa18ca8ab9d380a57775491db7639e7b93f56662e551ce0f9a0085",
            "kind": "host-effect",
            "capabilityId": "host.presentation",
            "operation": "loading"
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:showLoading:sha256:2028efe6e8c14247fc68a68291324cfde0c901a643828e6cf82dfc26ed957cf2",
            "capabilityId": "host.presentation",
            "operation": "loading"
          }
        ],
        "requiredHostCapabilities": [
          "host.presentation"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "showPopup",
      "category": "ui",
      "label": "Show Popup",
      "description": "Show a popup/modal dialog",
      "params": [
        {
          "name": "title",
          "type": "string"
        },
        {
          "name": "message",
          "type": "string"
        },
        {
          "name": "type",
          "type": "string"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/showPopup",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "allow",
      "grounding": "generated",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "ui",
        "atomic": true,
        "completion": "accepted"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "showPopup",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:showPopup:actions",
            "path": "actions",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:showPopup:message",
            "path": "message",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:showPopup:title",
            "path": "title",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:showPopup:type",
            "path": "type",
            "required": false,
            "role": "selector"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:showPopup:sha256:2c98f64ee204e8485463813a8b7c50621f1dff29e6e426c3d2aa2755431b9688",
            "kind": "host-effect",
            "capabilityId": "host.presentation",
            "operation": "popup"
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:showPopup:sha256:90bdd027fc20a2bdeb8d74e288d8169675f93cc2169dccafa28b7f8bc26eb4af",
            "capabilityId": "host.presentation",
            "operation": "popup"
          }
        ],
        "requiredHostCapabilities": [
          "host.presentation"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "showToast",
      "category": "ui",
      "label": "Show Toast",
      "description": "Display a transient toast notification (success / fail / info). Auto-clears after durationMs (default 3000ms) or user dismiss. For blocking confirmation use confirmAction.",
      "params": [
        {
          "name": "message",
          "type": "string",
          "required": true
        },
        {
          "name": "title",
          "type": "string",
          "description": "Toast heading. When present, `message`/`description` render as the body beneath it (falls back to `message` as the heading when omitted — fully backward compatible). L8 fwd4 residual repair #3 (2026-08-1x, m7-attribution-loops M6-L2-attribution.md): param-usage-drift measured 40/42 occurrences of qwen's prior consistently emitting this param while the pre-repair runtime silently dropped it."
        },
        {
          "name": "description",
          "type": "string"
        },
        {
          "name": "kind",
          "type": "string",
          "default": "default",
          "description": "Toast variant: 'success' | 'fail' | 'info' | 'default'. Preferred over `variant`. Wave 4 R4 canonical."
        },
        {
          "name": "variant",
          "type": "string",
          "default": "default",
          "description": "Corpus-alias for `kind`. Retained for backward compatibility — set `kind` in new flows."
        },
        {
          "name": "durationMs",
          "type": "number",
          "default": 3000,
          "description": "Auto-dismiss delay in milliseconds. 0 = persist until dismissed by user. Wave 4 R4."
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/showToast",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "allow",
      "grounding": "generated",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "ui",
        "atomic": true,
        "completion": "accepted"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "showToast",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:showToast:description",
            "path": "description",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:showToast:durationMs",
            "path": "durationMs",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:showToast:message",
            "path": "message",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:showToast:title",
            "path": "title",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:showToast:variant",
            "path": "variant",
            "required": false,
            "role": "selector"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:showToast:sha256:ae67b9268486bb652609dcdcfda61e91dbe28a90f0c7e991943113fc545cd557",
            "kind": "host-effect",
            "capabilityId": "host.presentation",
            "operation": "toast"
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:showToast:sha256:564712a3621664ec10b17ae92d9c4a990ecc67bfb0ff1f9a9c039e9a518186da",
            "capabilityId": "host.presentation",
            "operation": "toast"
          }
        ],
        "requiredHostCapabilities": [
          "host.presentation"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "simulateError",
      "deprecated": true,
      "deprecatedMessage": "simulateError is a test-only action with no runtime-v2 executor.",
      "category": "flow",
      "label": "Simulate Error",
      "description": "Throw a simulated error for testing tryCatch",
      "params": [
        {
          "name": "message",
          "type": "string",
          "default": "Simulated error"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": true
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/simulateError",
      "lifecycle": "deprecated",
      "registryExposure": "public",
      "runtimeImplemented": false,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": true
      },
      "generationPolicy": "alias-only",
      "grounding": "control-flow",
      "evidence": [
        "packages/cogo-action-registry/src/registry.ts"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "immediate"
      }
    },
    {
      "name": "sortByField",
      "category": "data",
      "label": "Sort By Field",
      "description": "Sort an array from a source state path by an object field and write the sorted result to a target path.",
      "params": [
        {
          "name": "source",
          "type": "string",
          "required": true,
          "description": "State path containing the source array"
        },
        {
          "name": "target",
          "type": "string",
          "required": true,
          "description": "State path to write the sorted array"
        },
        {
          "name": "field",
          "type": "string",
          "required": true,
          "description": "Object field to compare"
        },
        {
          "name": "direction",
          "type": "string",
          "default": "asc",
          "description": "Sort direction: asc | desc"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": true
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/sortByField",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": true
      },
      "generationPolicy": "allow",
      "grounding": "generated",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "immediate"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "sortByField",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:sortByField:direction",
            "path": "direction",
            "required": false,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:sortByField:field",
            "path": "field",
            "required": true,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:sortByField:source",
            "path": "source",
            "required": true,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:sortByField:target",
            "path": "target",
            "required": true,
            "role": "target"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:sortByField:sha256:5e680edc286f76bc1908e751533aa390759ed7860011a389f683935f75cfda7b",
            "kind": "state-target",
            "targetParam": "target"
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [],
        "missingConsumerPolicy": "reject-before-side-effects"
      }
    },
    {
      "name": "stopFlow",
      "category": "flow",
      "label": "Stop Flow",
      "description": "Stop the current flow execution",
      "params": [],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": true
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/stopFlow",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": true
      },
      "generationPolicy": "allow",
      "grounding": "control-flow",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "immediate"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "stopFlow",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:stopFlow:reason",
            "path": "reason",
            "required": false,
            "role": "input"
          }
        ],
        "resultChannels": [],
        "hostCapabilities": [],
        "requiredHostCapabilities": [],
        "missingConsumerPolicy": "reject-before-side-effects"
      }
    },
    {
      "name": "storage",
      "category": "storage",
      "label": "Storage",
      "description": "Read/write to persistent storage",
      "params": [
        {
          "name": "operation",
          "type": "string",
          "required": true,
          "description": "get | set | remove | clear"
        },
        {
          "name": "key",
          "type": "string"
        },
        {
          "name": "value",
          "type": "expression"
        },
        {
          "name": "resultPath",
          "type": "string"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/storage",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "allow",
      "grounding": "generated",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "sensitive",
      "semantics": {
        "domain": "system",
        "atomic": true,
        "completion": "immediate"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "storage",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:storage:key",
            "path": "key",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:storage:operation",
            "path": "operation",
            "required": false,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:storage:resultPath",
            "path": "resultPath",
            "required": false,
            "role": "target"
          },
          {
            "channelId": "parameter-channel:storage:secure",
            "path": "secure",
            "required": false,
            "role": "guard"
          },
          {
            "channelId": "parameter-channel:storage:value",
            "path": "value",
            "required": false,
            "role": "payload"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:storage:sha256:35cc4d65cc9ac5a00334e9a2638cf504c8ee5edd6b89b207b836f552281cf3ac",
            "kind": "host-effect",
            "when": {
              "param": "operation",
              "equals": [
                "remove"
              ]
            },
            "capabilityId": "host.storage",
            "operation": "remove"
          },
          {
            "channelId": "result-channel:storage:sha256:645a166a7da94edb1c4a288065710bf291213876e6b79a9769cc0aaf579bc277",
            "kind": "host-effect",
            "when": {
              "param": "operation",
              "equals": [
                "get"
              ]
            },
            "capabilityId": "host.storage",
            "operation": "get"
          },
          {
            "channelId": "result-channel:storage:sha256:8eb0bf143b471b05b24104f30138514bcc65604abc7bccc7cc5bd30c8791379d",
            "kind": "host-effect",
            "when": {
              "param": "operation",
              "equals": [
                "set"
              ]
            },
            "capabilityId": "host.storage",
            "operation": "set"
          },
          {
            "channelId": "result-channel:storage:sha256:ed56cd0b6b5bf3580701626f1586cffb743dc71de1c639d7d52ec7154161fdd9",
            "kind": "host-effect",
            "when": {
              "param": "operation",
              "equals": [
                "clear"
              ]
            },
            "capabilityId": "host.storage",
            "operation": "clear"
          },
          {
            "channelId": "result-channel:storage:sha256:ba5d8bd1aeb6348f627a7826a4425d32aca37a6b70edc01a8e9a9ebd9b19b9a3",
            "kind": "state-target",
            "when": {
              "param": "operation",
              "equals": [
                "get"
              ]
            },
            "targetParam": "resultPath"
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:storage:sha256:19c93c2a9d6e8fa31aee700b6d403fc5432ef0b121b90d1927512f9691c49f93",
            "capabilityId": "host.storage",
            "operation": "set",
            "when": {
              "param": "operation",
              "equals": [
                "set"
              ]
            }
          },
          {
            "channelId": "host-channel:storage:sha256:4a45020839a6f687aaa4152129641f4e547ffbf192df0173ae7d9953d8638197",
            "capabilityId": "host.storage",
            "operation": "get",
            "when": {
              "param": "operation",
              "equals": [
                "get"
              ]
            }
          },
          {
            "channelId": "host-channel:storage:sha256:4cf233dffdbdafddbb0a8da3674d62f0eeaf9e8a3c1b166e6333bdc5f42692b9",
            "capabilityId": "host.storage",
            "operation": "remove",
            "when": {
              "param": "operation",
              "equals": [
                "remove"
              ]
            }
          },
          {
            "channelId": "host-channel:storage:sha256:cd3a61f353f8e39be39dfa39a8315b24968003b53f2ee28d7c5a6206c6081047",
            "capabilityId": "host.storage",
            "operation": "clear",
            "when": {
              "param": "operation",
              "equals": [
                "clear"
              ]
            }
          }
        ],
        "requiredHostCapabilities": [
          "host.storage"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "supabaseAuth",
      "category": "auth",
      "label": "Supabase Auth",
      "description": "Authentication operations (signInWithPassword, signUp, signOut, getSession, getUser, resetPasswordForEmail, updateUser, signInWithOAuth, onAuthStateChange, enrollMfa, verifyMfa, unenrollMfa)",
      "params": [
        {
          "name": "method",
          "type": "string",
          "required": true,
          "description": "signInWithPassword | signUp | signOut | getSession | getUser | resetPasswordForEmail | updateUser | signInWithOAuth | onAuthStateChange | enrollMfa | verifyMfa | unenrollMfa"
        },
        {
          "name": "email",
          "type": "string",
          "description": "Email for signIn/signUp/resetPassword"
        },
        {
          "name": "password",
          "type": "string",
          "description": "Password for signIn/signUp/updateUser"
        },
        {
          "name": "provider",
          "type": "string",
          "description": "OAuth provider: google | apple | github | kakao"
        },
        {
          "name": "redirectTo",
          "type": "string",
          "description": "Redirect URL for OAuth/resetPassword"
        },
        {
          "name": "scopes",
          "type": "string",
          "description": "OAuth scopes (space-delimited)"
        },
        {
          "name": "metadata",
          "type": "object",
          "description": "User metadata for signUp/updateUser"
        },
        {
          "name": "code",
          "type": "string",
          "description": "TOTP code for MFA verify"
        },
        {
          "name": "factorId",
          "type": "string",
          "description": "MFA factor ID for verify/unenroll"
        },
        {
          "name": "resultTarget",
          "type": "string",
          "description": "State path for result"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/supabaseAuth",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": "adapter"
      },
      "generationPolicy": "adapter-only",
      "grounding": "datasource-adapter",
      "evidence": [
        "packages/cogo-runtime-v2/src/supabase-actions.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "sensitive",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "supabaseAuth",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:supabaseAuth:code",
            "path": "code",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:supabaseAuth:email",
            "path": "email",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:supabaseAuth:factorId",
            "path": "factorId",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:supabaseAuth:friendlyName",
            "path": "friendlyName",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:supabaseAuth:metadata",
            "path": "metadata",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:supabaseAuth:method",
            "path": "method",
            "required": false,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:supabaseAuth:password",
            "path": "password",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:supabaseAuth:provider",
            "path": "provider",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:supabaseAuth:redirectTo",
            "path": "redirectTo",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:supabaseAuth:resultTarget",
            "path": "resultTarget",
            "required": false,
            "role": "target"
          },
          {
            "channelId": "parameter-channel:supabaseAuth:scopes",
            "path": "scopes",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:supabaseAuth:triggerFlow",
            "path": "triggerFlow",
            "required": false,
            "role": "input"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:supabaseAuth:sha256:3273ed7786f42f8550b811d5879423d01aaebbcbc7348d350c8f8b69ced4c37e",
            "kind": "state-target",
            "targetParam": "resultTarget",
            "defaultTarget": "_results.auth"
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [
          "host.supabase"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "supabaseQuery",
      "category": "data",
      "label": "Supabase Query",
      "description": "Query data from Supabase",
      "params": [
        {
          "name": "table",
          "type": "string",
          "required": true
        },
        {
          "name": "select",
          "type": "string"
        },
        {
          "name": "filter",
          "type": "object"
        },
        {
          "name": "resultPath",
          "type": "string"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": true
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/supabaseQuery",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": "adapter"
      },
      "generationPolicy": "adapter-only",
      "grounding": "datasource-adapter",
      "evidence": [
        "packages/cogo-runtime-v2/src/supabase-actions.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "supabaseQuery",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:supabaseQuery:columns",
            "path": "columns",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:supabaseQuery:count",
            "path": "count",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:supabaseQuery:data",
            "path": "data",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:supabaseQuery:filters",
            "path": "filters",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:supabaseQuery:method",
            "path": "method",
            "required": false,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:supabaseQuery:order",
            "path": "order",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:supabaseQuery:range",
            "path": "range",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:supabaseQuery:resultTarget",
            "path": "resultTarget",
            "required": false,
            "role": "target"
          },
          {
            "channelId": "parameter-channel:supabaseQuery:single",
            "path": "single",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:supabaseQuery:table",
            "path": "table",
            "required": true,
            "role": "input"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:supabaseQuery:sha256:b82b1d2582863398c57b2983c9c2944a04f25e109b772a63b0207c06a71e57a2",
            "kind": "state-target",
            "targetParam": "resultTarget",
            "defaultTargetFromParam": {
              "prefix": "_results.",
              "param": "table"
            }
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [
          "host.supabase"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "supabaseRealtime",
      "category": "realtime",
      "label": "Supabase Realtime",
      "description": "Subscribe to postgres changes, broadcast messages, and presence — via Supabase Realtime channels",
      "params": [
        {
          "name": "action",
          "type": "string",
          "required": true,
          "description": "subscribe | unsubscribe | broadcast | trackPresence | untrackPresence"
        },
        {
          "name": "channel",
          "type": "string",
          "required": true,
          "description": "Channel name (unique per subscription)"
        },
        {
          "name": "eventType",
          "type": "string",
          "description": "postgres_changes | broadcast | presence (for subscribe)"
        },
        {
          "name": "event",
          "type": "string",
          "description": "INSERT | UPDATE | DELETE | * (postgres_changes) or custom event name (broadcast)"
        },
        {
          "name": "schema",
          "type": "string",
          "description": "Database schema (default: public)"
        },
        {
          "name": "table",
          "type": "string",
          "description": "Table name for postgres_changes"
        },
        {
          "name": "filter",
          "type": "string",
          "description": "Supabase filter (e.g. column=eq.value)"
        },
        {
          "name": "triggerFlow",
          "type": "string",
          "description": "Flow name to execute on data received"
        },
        {
          "name": "payload",
          "type": "object",
          "description": "Data to broadcast or presence state to track"
        },
        {
          "name": "state",
          "type": "object",
          "description": "Presence state object for trackPresence"
        },
        {
          "name": "resultTarget",
          "type": "string",
          "description": "State path for subscription result"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/supabaseRealtime",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "adapter-only",
      "grounding": "realtime-adapter",
      "evidence": [
        "packages/cogo-runtime-v2/src/supabase-actions.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "sensitive",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "supabaseRealtime",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:supabaseRealtime:action",
            "path": "action",
            "required": false,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:supabaseRealtime:channel",
            "path": "channel",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:supabaseRealtime:event",
            "path": "event",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:supabaseRealtime:eventType",
            "path": "eventType",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:supabaseRealtime:filter",
            "path": "filter",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:supabaseRealtime:payload",
            "path": "payload",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:supabaseRealtime:resultTarget",
            "path": "resultTarget",
            "required": false,
            "role": "target"
          },
          {
            "channelId": "parameter-channel:supabaseRealtime:schema",
            "path": "schema",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:supabaseRealtime:state",
            "path": "state",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:supabaseRealtime:table",
            "path": "table",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:supabaseRealtime:triggerFlow",
            "path": "triggerFlow",
            "required": false,
            "role": "input"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:supabaseRealtime:sha256:8e13e9ae245fb6ac5ac6b9ade14c409bb8b4ae1ec36d1f0db2375ab2cefee188",
            "kind": "state-target",
            "targetParam": "resultTarget",
            "defaultTarget": "_results.realtime"
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [
          "host.supabase"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "supabaseRpc",
      "category": "data",
      "label": "Supabase RPC",
      "description": "Call a Supabase RPC function with auth error detection and retry",
      "params": [
        {
          "name": "functionName",
          "type": "string",
          "required": true,
          "description": "RPC function name"
        },
        {
          "name": "args",
          "type": "object",
          "description": "Arguments to pass to the function"
        },
        {
          "name": "resultTarget",
          "type": "string",
          "description": "State path to store response"
        },
        {
          "name": "retryCount",
          "type": "number",
          "default": 0,
          "description": "Max retries (0-2)"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": true
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/supabaseRpc",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": "adapter"
      },
      "generationPolicy": "adapter-only",
      "grounding": "datasource-adapter",
      "evidence": [
        "packages/cogo-runtime-v2/src/supabase-actions.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "supabaseRpc",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:supabaseRpc:args",
            "path": "args",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:supabaseRpc:functionName",
            "path": "functionName",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:supabaseRpc:resultTarget",
            "path": "resultTarget",
            "required": false,
            "role": "target"
          },
          {
            "channelId": "parameter-channel:supabaseRpc:retryCount",
            "path": "retryCount",
            "required": false,
            "role": "input"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:supabaseRpc:sha256:a1b957966327040ab323b81c13f467b2c56f5714f2ee779c90dd54b577447c89",
            "kind": "state-target",
            "targetParam": "resultTarget",
            "defaultTarget": "_results.rpc"
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [
          "host.supabase"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "supabaseStorage",
      "category": "storage",
      "label": "Supabase Storage",
      "description": "File storage operations (list, download, remove, getPublicUrl, upload, createSignedUrl)",
      "params": [
        {
          "name": "bucket",
          "type": "string",
          "required": true,
          "description": "Storage bucket name"
        },
        {
          "name": "method",
          "type": "string",
          "default": "list",
          "description": "list | download | remove | getPublicUrl | upload | createSignedUrl"
        },
        {
          "name": "path",
          "type": "string",
          "description": "File path within the bucket"
        },
        {
          "name": "file",
          "type": "object",
          "description": "File or Blob for upload"
        },
        {
          "name": "upsert",
          "type": "boolean",
          "description": "Overwrite existing file on upload"
        },
        {
          "name": "contentType",
          "type": "string",
          "description": "MIME type for upload"
        },
        {
          "name": "expiresIn",
          "type": "number",
          "description": "Signed URL expiry in seconds"
        },
        {
          "name": "resultTarget",
          "type": "string",
          "description": "State path for result"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/supabaseStorage",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": "adapter"
      },
      "generationPolicy": "adapter-only",
      "grounding": "datasource-adapter",
      "evidence": [
        "packages/cogo-runtime-v2/src/supabase-actions.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "sensitive",
      "semantics": {
        "domain": "system",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "supabaseStorage",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:supabaseStorage:bucket",
            "path": "bucket",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:supabaseStorage:contentType",
            "path": "contentType",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:supabaseStorage:expiresIn",
            "path": "expiresIn",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:supabaseStorage:file",
            "path": "file",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:supabaseStorage:method",
            "path": "method",
            "required": false,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:supabaseStorage:path",
            "path": "path",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:supabaseStorage:paths",
            "path": "paths",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:supabaseStorage:resultTarget",
            "path": "resultTarget",
            "required": false,
            "role": "target"
          },
          {
            "channelId": "parameter-channel:supabaseStorage:upsert",
            "path": "upsert",
            "required": false,
            "role": "input"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:supabaseStorage:sha256:70d582ce232d147b5474c697f5b159a6822dfb5fdb1ee9840a07f2f929f5e7a1",
            "kind": "state-target",
            "targetParam": "resultTarget",
            "defaultTarget": "_results.storage"
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [
          "host.supabase"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "throttleAction",
      "category": "flow",
      "label": "Throttle Action",
      "description": "Throttle an action to prevent rapid execution",
      "params": [
        {
          "name": "action",
          "type": "string",
          "required": true
        },
        {
          "name": "params",
          "type": "object"
        },
        {
          "name": "interval",
          "type": "number",
          "default": 1000
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": true
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/throttleAction",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": true
      },
      "generationPolicy": "allow",
      "grounding": "control-flow",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "business",
        "atomic": false,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "throttleAction",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:throttleAction:action",
            "path": "action",
            "required": true,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:throttleAction:interval",
            "path": "interval",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:throttleAction:key",
            "path": "key",
            "required": false,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:throttleAction:params",
            "path": "params",
            "required": false,
            "role": "payload"
          }
        ],
        "resultChannels": [],
        "hostCapabilities": [],
        "requiredHostCapabilities": [],
        "missingConsumerPolicy": "reject-before-side-effects"
      }
    },
    {
      "name": "transactionAction",
      "category": "flow",
      "label": "Transaction",
      "description": "Execute actions as a transaction with rollback",
      "params": [
        {
          "name": "actions",
          "type": "array",
          "required": true
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": true
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/transactionAction",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": true
      },
      "generationPolicy": "allow",
      "grounding": "control-flow",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "business",
        "atomic": false,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "transactionAction",
        "runtimeAliases": [],
        "reads": [
          {
            "aliases": [
              "steps"
            ],
            "channelId": "parameter-channel:transactionAction:actions",
            "path": "actions",
            "required": true,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:transactionAction:resultTarget",
            "path": "resultTarget",
            "required": false,
            "role": "target"
          },
          {
            "channelId": "parameter-channel:transactionAction:rollback",
            "path": "rollback",
            "required": false,
            "role": "payload"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:transactionAction:sha256:c949fbb074f16f1acd95aa5c07c431f37e6ba80035d82eadc0ac20c4f21ea06d",
            "kind": "state-target",
            "targetParam": "resultTarget",
            "defaultTarget": "_results.transaction"
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [],
        "missingConsumerPolicy": "reject-before-side-effects"
      }
    },
    {
      "name": "updateWhere",
      "category": "data",
      "label": "Update Where",
      "description": "Apply the updates dictionary to every array row the predicate matches.",
      "params": [
        {
          "name": "target",
          "type": "string",
          "required": true,
          "description": "Bare state path of the array to update (runtime reads params.target)"
        },
        {
          "name": "predicate",
          "type": "expression",
          "required": true,
          "description": "Bare arrow predicate (e.g. \"item => item.id === '#{event.itemId}'\") identifying rows to update"
        },
        {
          "name": "updates",
          "type": "object",
          "description": "Column-value dictionary applied to predicated rows (alias-dispatched to setState operation=updateWhere update)"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/updateWhere",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "allow",
      "grounding": "generated",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "immediate"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "updateWhere",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:updateWhere:$",
            "path": "$",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:updateWhere:target",
            "path": "target",
            "required": true,
            "role": "target"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:updateWhere:sha256:5e680edc286f76bc1908e751533aa390759ed7860011a389f683935f75cfda7b",
            "kind": "state-target",
            "targetParam": "target"
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [],
        "missingConsumerPolicy": "reject-before-side-effects"
      }
    },
    {
      "name": "uploadFiles",
      "category": "system",
      "label": "Upload Files",
      "description": "Upload selected files through a platform or datasource adapter.",
      "params": [],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/uploadFiles",
      "lifecycle": "active",
      "registryExposure": "runtime-only",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "adapter-only",
      "grounding": "native-adapter",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "sensitive",
      "semantics": {
        "domain": "system",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "uploadFiles",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:uploadFiles:files",
            "path": "files",
            "required": false,
            "role": "payload"
          },
          {
            "aliases": [
              "target"
            ],
            "channelId": "parameter-channel:uploadFiles:resultTarget",
            "path": "resultTarget",
            "required": false,
            "role": "target"
          },
          {
            "aliases": [
              "datasourceId"
            ],
            "channelId": "parameter-channel:uploadFiles:source",
            "path": "source",
            "required": true,
            "role": "selector"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:uploadFiles:sha256:4a393f959b4d793fd47d310f26bee380cd415cc1993b56f49caa3903a60cfa94",
            "kind": "host-effect",
            "capabilityId": "host.datasource",
            "operation": "upload"
          },
          {
            "channelId": "result-channel:uploadFiles:sha256:cfa477a83e214c8089a53ed6b0f1b8ef3c0729ade8233b071fd27086dcec6287",
            "kind": "state-target",
            "targetParam": "resultTarget"
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:uploadFiles:sha256:2cf59c32dd8e5f10f87b6c9b4af5f9abea01cb58cbfe96ddebd74f6008d2a280",
            "capabilityId": "host.datasource",
            "operation": "upload"
          }
        ],
        "requiredHostCapabilities": [
          "host.datasource"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "upsertWhere",
      "category": "data",
      "label": "Upsert Where",
      "description": "Update the array row matched by matchExpr with onMatch, or append onNew when no row matches.",
      "params": [
        {
          "name": "target",
          "type": "string",
          "required": true,
          "description": "Bare state path of the array to upsert into (runtime reads params.target)"
        },
        {
          "name": "matchExpr",
          "type": "expression",
          "required": true,
          "description": "Bare arrow predicate (e.g. \"item => item.id === '#{event.itemId}'\") selecting the row to update (alias-dispatched to setState operation=upsert match)"
        },
        {
          "name": "onMatch",
          "type": "object",
          "description": "Column-value dictionary applied when matchExpr finds a row"
        },
        {
          "name": "onNew",
          "type": "object",
          "description": "Column-value dictionary appended when no row matches"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/upsertWhere",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "allow",
      "grounding": "generated",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "immediate"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "upsertWhere",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:upsertWhere:$",
            "path": "$",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:upsertWhere:target",
            "path": "target",
            "required": true,
            "role": "target"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:upsertWhere:sha256:5e680edc286f76bc1908e751533aa390759ed7860011a389f683935f75cfda7b",
            "kind": "state-target",
            "targetParam": "target"
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [],
        "missingConsumerPolicy": "reject-before-side-effects"
      }
    },
    {
      "name": "validate",
      "category": "form",
      "label": "Validate",
      "description": "Validate a value against a list of rules. Returns {valid, message?} captured at _results.<step.name>. Supported rule types: required, minLength, maxLength, pattern, email, min, max.",
      "params": [
        {
          "name": "target",
          "type": "expression",
          "required": true,
          "description": "Value to validate"
        },
        {
          "name": "rules",
          "type": "array",
          "required": true,
          "description": "Array of {type, value?, message?} rule objects"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": true
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/validate",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": true,
        "flutter": "adapter",
        "ssr": true
      },
      "generationPolicy": "allow",
      "grounding": "generated",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "public",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "immediate"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "validate",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:validate:rules",
            "path": "rules",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:validate:target",
            "path": "target",
            "required": true,
            "role": "input"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:validate:sha256:1182f31e9f03c5704bab18950e9381188a2a4411c1380c47c4fce875f9383d02",
            "kind": "return-capture",
            "capture": "step-name"
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [],
        "missingConsumerPolicy": "reject-before-side-effects"
      }
    },
    {
      "name": "wallet.create",
      "category": "crypto",
      "label": "Wallet Create",
      "description": "Wallet action registered through the wallet action adapter.",
      "params": [],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/wallet.create",
      "lifecycle": "active",
      "registryExposure": "runtime-only",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "adapter-only",
      "grounding": "wallet-adapter",
      "evidence": [
        "packages/cogo-runtime-v2/src/wallet-actions.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "sensitive",
      "semantics": {
        "domain": "system",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "wallet.create",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:wallet.create:$",
            "path": "$",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:wallet.create:resultTarget",
            "path": "resultTarget",
            "required": false,
            "role": "target"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:wallet.create:sha256:311f4912635f1cbd6dee5ed609a0373489e3b5b8f0e4c8c1967184240f81da1c",
            "kind": "state-target",
            "targetParam": "resultTarget",
            "defaultTarget": "_results.wallet.create"
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [
          "host.wallet-api"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "wallet.estimateFee",
      "category": "crypto",
      "label": "Wallet Estimate Fee",
      "description": "Wallet action registered through the wallet action adapter.",
      "params": [],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/wallet.estimateFee",
      "lifecycle": "active",
      "registryExposure": "runtime-only",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "adapter-only",
      "grounding": "wallet-adapter",
      "evidence": [
        "packages/cogo-runtime-v2/src/wallet-actions.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "sensitive",
      "semantics": {
        "domain": "system",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "wallet.estimateFee",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:wallet.estimateFee:$",
            "path": "$",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:wallet.estimateFee:resultTarget",
            "path": "resultTarget",
            "required": false,
            "role": "target"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:wallet.estimateFee:sha256:dadb667939bc821b6f75e59a1cb99f228fe3d2b1add00c2f1c6a8125ba0bfd26",
            "kind": "state-target",
            "targetParam": "resultTarget",
            "defaultTarget": "_results.wallet.fee"
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [
          "host.wallet-api"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "wallet.getBalance",
      "category": "crypto",
      "label": "Wallet Get Balance",
      "description": "Wallet action registered through the wallet action adapter.",
      "params": [],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/wallet.getBalance",
      "lifecycle": "active",
      "registryExposure": "runtime-only",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "adapter-only",
      "grounding": "wallet-adapter",
      "evidence": [
        "packages/cogo-runtime-v2/src/wallet-actions.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "sensitive",
      "semantics": {
        "domain": "system",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "wallet.getBalance",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:wallet.getBalance:resultTarget",
            "path": "resultTarget",
            "required": false,
            "role": "target"
          },
          {
            "channelId": "parameter-channel:wallet.getBalance:walletId",
            "path": "walletId",
            "required": true,
            "role": "input"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:wallet.getBalance:sha256:3a2c0fba555b86ef8f90edb88b14d004afb52b381f9f84d29a9341a85f8ab79d",
            "kind": "state-target",
            "targetParam": "resultTarget",
            "defaultTarget": "_results.wallet.balance"
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [
          "host.wallet-api"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "wallet.getTxHistory",
      "category": "crypto",
      "label": "Wallet Get Tx History",
      "description": "Wallet action registered through the wallet action adapter.",
      "params": [],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/wallet.getTxHistory",
      "lifecycle": "active",
      "registryExposure": "runtime-only",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "adapter-only",
      "grounding": "wallet-adapter",
      "evidence": [
        "packages/cogo-runtime-v2/src/wallet-actions.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "sensitive",
      "semantics": {
        "domain": "system",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "wallet.getTxHistory",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:wallet.getTxHistory:limit",
            "path": "limit",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:wallet.getTxHistory:network",
            "path": "network",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:wallet.getTxHistory:offset",
            "path": "offset",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:wallet.getTxHistory:resultTarget",
            "path": "resultTarget",
            "required": false,
            "role": "target"
          },
          {
            "channelId": "parameter-channel:wallet.getTxHistory:walletId",
            "path": "walletId",
            "required": true,
            "role": "input"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:wallet.getTxHistory:sha256:3bab421696b9768b1f033ce98f17db65dc7e43944877b12ff3ee8317f41fe1a0",
            "kind": "state-target",
            "targetParam": "resultTarget",
            "defaultTarget": "_results.wallet.txHistory"
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [
          "host.wallet-api"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "wallet.getTxStatus",
      "category": "crypto",
      "label": "Wallet Get Tx Status",
      "description": "Wallet action registered through the wallet action adapter.",
      "params": [],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/wallet.getTxStatus",
      "lifecycle": "active",
      "registryExposure": "runtime-only",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "adapter-only",
      "grounding": "wallet-adapter",
      "evidence": [
        "packages/cogo-runtime-v2/src/wallet-actions.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "sensitive",
      "semantics": {
        "domain": "system",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "wallet.getTxStatus",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:wallet.getTxStatus:requestId",
            "path": "requestId",
            "required": true,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:wallet.getTxStatus:resultTarget",
            "path": "resultTarget",
            "required": false,
            "role": "target"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:wallet.getTxStatus:sha256:bfb9213880ef0cb78ef7cdc99e7ebb3fa41bc7b9d539c721322140cc3c8161fc",
            "kind": "state-target",
            "targetParam": "resultTarget",
            "defaultTarget": "_results.wallet.txStatus"
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [
          "host.wallet-api"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "wallet.list",
      "category": "crypto",
      "label": "Wallet List",
      "description": "Wallet action registered through the wallet action adapter.",
      "params": [],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/wallet.list",
      "lifecycle": "active",
      "registryExposure": "runtime-only",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "adapter-only",
      "grounding": "wallet-adapter",
      "evidence": [
        "packages/cogo-runtime-v2/src/wallet-actions.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "sensitive",
      "semantics": {
        "domain": "system",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "wallet.list",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:wallet.list:network",
            "path": "network",
            "required": false,
            "role": "input"
          },
          {
            "channelId": "parameter-channel:wallet.list:resultTarget",
            "path": "resultTarget",
            "required": false,
            "role": "target"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:wallet.list:sha256:f6507cd3b9befce750f02a7b2b4f22d55ee0ef62d2d382ced46c8cae9accc5c2",
            "kind": "state-target",
            "targetParam": "resultTarget",
            "defaultTarget": "_results.wallet.list"
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [
          "host.wallet-api"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "wallet.send",
      "category": "crypto",
      "label": "Wallet Send",
      "description": "Wallet action registered through the wallet action adapter.",
      "params": [],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/wallet.send",
      "lifecycle": "active",
      "registryExposure": "runtime-only",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "adapter-only",
      "grounding": "wallet-adapter",
      "evidence": [
        "packages/cogo-runtime-v2/src/wallet-actions.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "sensitive",
      "semantics": {
        "domain": "system",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "wallet.send",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:wallet.send:$",
            "path": "$",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:wallet.send:resultTarget",
            "path": "resultTarget",
            "required": false,
            "role": "target"
          },
          {
            "channelId": "parameter-channel:wallet.send:walletId",
            "path": "walletId",
            "required": true,
            "role": "input"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:wallet.send:sha256:c278001fe367b8e1ae9869112cfdb44328207d4c926431be6a9828f7c92c3231",
            "kind": "state-target",
            "targetParam": "resultTarget",
            "defaultTarget": "_results.wallet.send"
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [
          "host.wallet-api"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "wallet.syncBalance",
      "category": "crypto",
      "label": "Wallet Sync Balance",
      "description": "Wallet action registered through the wallet action adapter.",
      "params": [],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/wallet.syncBalance",
      "lifecycle": "active",
      "registryExposure": "runtime-only",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "adapter-only",
      "grounding": "wallet-adapter",
      "evidence": [
        "packages/cogo-runtime-v2/src/wallet-actions.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "sensitive",
      "semantics": {
        "domain": "system",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "wallet.syncBalance",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:wallet.syncBalance:resultTarget",
            "path": "resultTarget",
            "required": false,
            "role": "target"
          },
          {
            "channelId": "parameter-channel:wallet.syncBalance:walletId",
            "path": "walletId",
            "required": true,
            "role": "input"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:wallet.syncBalance:sha256:eccfce7ff25ef95d37c1c85b12d77f03b925187fa9f5fc367d2d5de817cd4f57",
            "kind": "state-target",
            "targetParam": "resultTarget",
            "defaultTarget": "_results.wallet.syncBalance"
          }
        ],
        "hostCapabilities": [],
        "requiredHostCapabilities": [
          "host.wallet-api"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "web3",
      "category": "crypto",
      "label": "Web3",
      "description": "Web3 wallet operation",
      "params": [
        {
          "name": "action",
          "type": "string",
          "required": true
        },
        {
          "name": "chainId",
          "type": "number"
        },
        {
          "name": "to",
          "type": "string"
        },
        {
          "name": "value",
          "type": "string"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": false,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/web3",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": true,
        "reactNative": false,
        "flutter": false,
        "ssr": false
      },
      "generationPolicy": "allow",
      "grounding": "generated",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "sensitive",
      "semantics": {
        "domain": "system",
        "atomic": true,
        "completion": "completed"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "web3",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:web3:$",
            "path": "$",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:web3:resultTarget",
            "path": "resultTarget",
            "required": false,
            "role": "target"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:web3:sha256:f883799a399eb8f5f28d58f9cfee4064d73b931ea5f3d546fa7586d7bd07dac1",
            "kind": "host-effect",
            "capabilityId": "host.web3",
            "operation": "invoke"
          },
          {
            "channelId": "result-channel:web3:sha256:6878d58a76dd710b5ccceef7b95676b74974fa05b42e85e1e75842272d265f1e",
            "kind": "state-target",
            "targetParam": "resultTarget",
            "defaultTarget": "_results.web3"
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:web3:sha256:6b84dca0827f54da95a5d521d5200bc996b358c05c3a9293667e8909ca9fbf00",
            "capabilityId": "host.web3",
            "operation": "invoke"
          }
        ],
        "requiredHostCapabilities": [
          "host.web3"
        ],
        "missingConsumerPolicy": "block-host"
      }
    },
    {
      "name": "websocket",
      "category": "network",
      "label": "WebSocket",
      "description": "Connect/send via WebSocket",
      "params": [
        {
          "name": "url",
          "type": "string",
          "required": true
        },
        {
          "name": "action",
          "type": "string",
          "default": "connect",
          "description": "connect | send | close"
        },
        {
          "name": "data",
          "type": "expression"
        },
        {
          "name": "connectionId",
          "type": "string"
        }
      ],
      "platform": {
        "web": true,
        "reactNative": true,
        "ssr": false
      },
      "aliases": [],
      "canonicalAction": null,
      "ontologyIri": "https://cogo.xyz/instances/action/websocket",
      "lifecycle": "active",
      "registryExposure": "public",
      "runtimeImplemented": true,
      "targetSupport": {
        "web": "adapter",
        "reactNative": "adapter",
        "flutter": "adapter",
        "ssr": false
      },
      "generationPolicy": "adapter-only",
      "grounding": "realtime-adapter",
      "evidence": [
        "packages/cogo-runtime-v2/src/action-flow-engine.ts",
        "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl"
      ],
      "securityClass": "sensitive",
      "semantics": {
        "domain": "business",
        "atomic": true,
        "completion": "immediate"
      },
      "consumerCatalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
      "consumerContract": {
        "action": "websocket",
        "runtimeAliases": [],
        "reads": [
          {
            "channelId": "parameter-channel:websocket:action",
            "path": "action",
            "required": false,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:websocket:connectionId",
            "path": "connectionId",
            "required": false,
            "role": "selector"
          },
          {
            "channelId": "parameter-channel:websocket:data",
            "path": "data",
            "required": false,
            "role": "payload"
          },
          {
            "channelId": "parameter-channel:websocket:resultTarget",
            "path": "resultTarget",
            "required": false,
            "role": "target"
          },
          {
            "channelId": "parameter-channel:websocket:url",
            "path": "url",
            "required": false,
            "role": "input"
          }
        ],
        "resultChannels": [
          {
            "channelId": "result-channel:websocket:sha256:e8b236769d68197e842f57093d4c75334bb4cbe5ccc82a4270f8291e94079282",
            "kind": "host-effect",
            "capabilityId": "host.websocket",
            "operation": "dispatch"
          },
          {
            "channelId": "result-channel:websocket:sha256:64ef9500c66ec5f80b1ff16fe6a0113a02900fefac75c3a7ef063413154c6f5e",
            "kind": "state-target",
            "targetParam": "resultTarget",
            "defaultTargetFromParam": {
              "prefix": "_results.ws.",
              "param": "connectionId",
              "fallback": "default"
            },
            "targetSuffixes": [
              "__ws",
              "connected",
              "lastMessage"
            ]
          }
        ],
        "hostCapabilities": [
          {
            "channelId": "host-channel:websocket:sha256:9e42b54be47e6f5dea504d06c16d4fb6846976988573f314ad3cde463d154bae",
            "capabilityId": "host.websocket",
            "operation": "dispatch"
          }
        ],
        "requiredHostCapabilities": [
          "host.websocket"
        ],
        "missingConsumerPolicy": "block-host"
      }
    }
  ]
}
